import React, { useEffect, useState, useRef, useContext } from "react";
import Select from "react-select";
import axios from "axios";
import NavBar from "../component/Navbar.js";
import { Link, NavLink, useSearchParams, useNavigate } from "react-router-dom";
import Footer from "../component/Footer.js";
import { StrokedText } from "stroked-text";
import Receipt from "../component/Receipt.js";
import { AuthContext } from "../App";

const Info = () => {
  const [searchParams] = useSearchParams();
  const pkg = searchParams.get("pkg") || "ta";
  const navigate = useNavigate();
  const [scrollPercent, setScrollPercent] = useState(0);
  const scrollRef = useRef(null);
  const [currentText, setCurrentText] = useState("TYPE OF USER");
  const [popup, setPopup] = useState(false);
  const [pdpa, setPdpa] = useState(false);
  const [isFormComplete, setIsFormComplete] = useState(false);
  const { user, isFetching, apiUrl } = useContext(AuthContext);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [price, setPrice] = useState(0);
  const [dial, setDial] = useState([]);
  const [countries, setCountries] = useState([]);
  const [phone, setPhone] = useState(11);
  const [inPassport, setInPassport] = useState("");
  const [inId, setInId] = useState("");
  const [inPhone, setInPhone] = useState("");
  const [inEmail, setInEmail] = useState("");
  // const [id, setId] = useState(12);
  // const [passport, setPassport] = useState(9);
  const [infoCountry, setInfoCountry] = useState([]);
  const [changevehicle, setChangeVehicle] = useState("NO");
  const [newUser, setNewUser] = useState(false);
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0"); // เดือนเริ่มจาก 0
  const dd = String(today.getDate()).padStart(2, "0");
  const localToday = `${yyyy}-${mm}-${dd}`;
  const [barSticky, setBarSticky] = useState(false);

  const [typeofuser, setTypeofUser] = useState({
    product: "",
    carType: "",
    period: "",
    type: "Personal",
  });

  const [user_personal, setUser_Personal] = useState({
    title: "",
    firstName: "",
    lastName: "",
    idcardNumber: "",
    passportNumber: "",
    nationality: "",
    birthDate: "",
    countryCode: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    province: "",
  });
  const [user_corporate, setUser_Corporate] = useState({
    companyName: "",
    companyAddress: "",
    title: "",
    firstName: "",
    lastName: "",
    idcardNumber: "",
    passportNumber: "",
    nationality: "",
    birthDate: "",
    countryCode: "",
    phoneNumber: "",
    email: "",
    address: "",
    city: "",
    zipCode: "",
    province: "",
  });
  const [vehicle, setVehicle] = useState({
    years: "",
    brands: "",
    model: "",
    color: "",
    VIN: "",
    engineNumber: "",
    numberPlate: "",
    country: "",
  });
  const [vehicleNew, setVehicleNew] = useState({
    years: "",
    brands: "",
    model: "",
    color: "",
    VIN: "",
    engineNumber: "",
    numberPlate: "",
    country: "",
  });
  const [car, setCar] = useState({
    years: "",
    brands: "",
    model: "",
    color: "",
    VIN: "",
    engineNumber: "",
    numberPlate: "",
    country: "",
  });

  const [travel, setTravel] = useState({
    travelStart: "",
    returnDate: "",
    departurePort: "",
    arrivalPort: "",
    numberPassenger: 1,
  });
  const maxDate = travel.travelStart
    ? new Date(
        new Date(travel.travelStart).getTime() +
          ((parseInt(typeofuser.period, 10) || 0) - 1) * 86400000
      )
        .toISOString()
        .split("T")[0]
    : "";

  const [passengers, setPassengers] = useState(
    Array.from({ length: travel.numberPassenger }).map(() => ({
      firstName: "",
      lastName: "",
      age: "",
      nationality: "",
      idCardNumber: "",
    }))
  );
  const [error, setError] = useState(
    Array.from({ length: travel.numberPassenger }).map(() => ({
      errorId: "",
    }))
  );

  const [creditCard, setCreditCard] = useState({
    cardHolder: "",
    cardNumber: "",
    expirationDate: "",
    cvv: "",
  });

  const [checked, setChecked] = useState({
    privacy: false,
    reservation: false,
    marketing: false,
  });

  const handleChange = (e) => {
    setChecked({ ...checked, [e.target.name]: e.target.checked });
  };
  const [errorPhone, setErrorPhone] = useState("");
  const [errorPassport, setErrorPassport] = useState("");
  const [errorId, setErrorId] = useState("");
  const [emailError, setEmailError] = useState("");

  const validatePhone = (value) => {
    if (value && value.length !== phone) {
      setErrorPhone(`Please input ${phone} numbers`);
    } else {
      setErrorPhone("");
      if (typeofuser.type === "Personal") {
        updatePersonal("phoneNumber", value);
        console.log("personal");
      } else {
        updateCorporate("phoneNumber", value);
        console.log("corporate");
      }
      openPopup();
    }
    console.log(value);
  };
  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
      setEmailError("Invalid email format.");
    } else {
      setEmailError("");
      if (typeofuser.type === "Personal") {
        updatePersonal("email", value);
        console.log("personal");
      } else {
        updateCorporate("email", value);
        console.log("corporate");
      }
      openPopup();
    }
    console.log(value);
  };
  const validateId = (value) => {
    if (value && (value.length < 9 || value.length > 16)) {
      // setErrorId(`Please input ${id} characters`);
      setErrorId("Please input 9-16 characters");
    } else {
      setErrorId("");
      if (typeofuser.type === "Personal") {
        updatePersonal("idcardNumber", value);
        console.log("personal");
      } else {
        updateCorporate("idcardNumber", value);
        console.log("corporate");
      }
      openPopup();
    }
    console.log(value);
  };

  const validatePassport = (value) => {
    if (value && value.length !== 9) {
      // setErrorPassport(`Please input ${passport} characters`);
      setErrorPassport("Please input 9 characters");
    } else {
      setErrorPassport("");
      if (typeofuser.type === "Personal") {
        updatePersonal("passportNumber", value);
        console.log("personal");
      } else {
        updateCorporate("passportNumber", value);
        console.log("corporate");
      }
      openPopup();
    }
    console.log(value);
  };
  const validateIdPass = (index, value) => {
    if (value && (value.length < 9 || value.length > 16)) {
      // setErrorId(`Please input ${id} characters`);
      handleId(index, "errorId", "Please input 9-16 characters");
    } else {
      handleId(index, "errorId", "");
      openPopup();
    }
  };
  const calculateDays = () => {
    if (travel.travelStart && travel.returnDate) {
      const start = new Date(travel.travelStart);
      const end = new Date(travel.returnDate);
      const diffTime = Math.abs(end - start) + 1;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
    return 0;
  };

  const handlePayment = () => {
    const isComplete = (obj) =>
      Object.values(obj).every((value) => value !== "");
    if (user === undefined) {
      axios
        .post(`${apiUrl}/createuser`, {})
        .then((res) => {})
        .catch((error) => {});
      setNewUser(true);
    }
    if (
      isFormComplete &&
      checked.privacy &&
      checked.reservation &&
      checked.marketing &&
      isComplete(creditCard)
    ) {
      setPopup(false);

      axios
        .post(`${apiUrl}/purchase`, {
          user_id: user?.id,
          product: typeofuser.product,
          cartype: typeofuser.carType,
          period: typeofuser.period,
          years: changevehicle === "NO" ? vehicle.years : vehicleNew.years,
          brands: changevehicle === "NO" ? vehicle.brands : vehicleNew.brands,
          model: changevehicle === "NO" ? vehicle.model : vehicleNew.model,
          color: changevehicle === "NO" ? vehicle.color : vehicleNew.color,
          vin: changevehicle === "NO" ? vehicle.VIN : vehicleNew.VIN,
          enginenumber:
            changevehicle === "NO"
              ? vehicle.engineNumber
              : vehicleNew.engineNumber,
          numberplate:
            changevehicle === "NO"
              ? vehicle.numberPlate
              : vehicleNew.numberPlate,
          country:
            changevehicle === "NO" ? vehicle.country : vehicleNew.country,
          companyname:
            typeofuser.type === "Corporate" ? user_corporate.companyName : "",
          companyaddress:
            typeofuser.type === "Corporate"
              ? user_corporate.companyAddress
              : "",
          title:
            typeofuser.type === "Corporate"
              ? user_corporate.title
              : user_personal.title,
          firstname:
            typeofuser.type === "Corporate"
              ? user_corporate.firstName
              : user_personal.firstName,
          lastname:
            typeofuser.type === "Corporate"
              ? user_corporate.lastName
              : user_personal.lastName,
          idcardnumber:
            typeofuser.type === "Corporate"
              ? user_corporate.idcardNumber
              : user_personal.idcardNumber,
          passportnumber:
            typeofuser.type === "Corporate"
              ? user_corporate.passportNumber
              : user_personal.passportNumber,
          nationality:
            typeofuser.type === "Corporate"
              ? user_corporate.nationality
              : user_personal.nationality,
          dateofbirth:
            typeofuser.type === "Corporate"
              ? user_corporate.birthDate
              : user_personal.birthDate,
          countrycode:
            typeofuser.type === "Corporate"
              ? user_corporate.countryCode
              : user_personal.countryCode,
          phonenumber:
            typeofuser.type === "Corporate"
              ? user_corporate.phoneNumber
              : user_personal.phoneNumber,
          email:
            typeofuser.type === "Corporate"
              ? user_corporate.email
              : user_personal.email,
          address:
            typeofuser.type === "Corporate"
              ? user_corporate.address
              : user_personal.address,
          city:
            typeofuser.type === "Corporate"
              ? user_corporate.city
              : user_personal.city,
          zipcode:
            typeofuser.type === "Corporate"
              ? user_corporate.zipCode
              : user_personal.zipCode,
          province:
            typeofuser.type === "Corporate"
              ? user_corporate.province
              : user_personal.province,
          traveldate: travel.travelStart,
          returndate: travel.returnDate,
          departureport: travel.departurePort,
          arriveport: travel.arrivalPort,
          passenger: passengers,
          price: price,
        })
        .then((res) => {
          if (typeofuser.type === "Corporate") {
            axios.post(`${apiUrl}/changecorporate`, {
              user_id: user?.id,
              companyname: user_corporate.companyName,
              companyaddress: user_corporate.companyAddress,
              title: user_corporate.title,
              firstname: user_corporate.firstName,
              lastname: user_corporate.lastName,
              idcardnumber: user_corporate.idcardNumber,
              passportnumber: user_corporate.passportNumber,
              nationality: user_corporate.national,
              dateofbirth: user_corporate.birthDate,
              countrycode: user_corporate.countryCode,
              phonenumber: user_corporate.phoneNumber,
              email: user_corporate.email,
              address: user_corporate.address,
              city: user_corporate.city,
              zipcode: user_corporate.zipCode,
            });
          } else {
            axios.post(`${apiUrl}/changepersonal`, {
              user_id: user?.id,
              title: user_personal.title,
              firstname: user_personal.firstName,
              lastname: user_personal.lastName,
              idcardnumber: user_personal.idcardNumber,
              passportnumber: user_personal.passportNumber,
              nationality: user_personal.national,
              dateofbirth: user_personal.birthDate,
              countrycode: user_personal.countryCode,
              phonenumber: user_personal.phoneNumber,
              email: user_personal.email,
              address: user_personal.address,
              city: user_personal.city,
              zipcode: user_personal.zipCode,
            });
          }
          axios.post(`${apiUrl}/changevehicle`, {
            user_id: user?.id,
            year: changevehicle === "NO" ? vehicle.years : vehicleNew.years,
            brand: changevehicle === "NO" ? vehicle.brands : vehicleNew.brands,
            model: changevehicle === "NO" ? vehicle.model : vehicleNew.model,
            color: changevehicle === "NO" ? vehicle.color : vehicleNew.color,
            vin: changevehicle === "NO" ? vehicle.VIN : vehicleNew.VIN,
            enginenumber:
              changevehicle === "NO"
                ? vehicle.engineNumber
                : vehicleNew.engineNumber,
            numberplate:
              changevehicle === "NO"
                ? vehicle.numberPlate
                : vehicleNew.numberPlate,
            country:
              changevehicle === "NO" ? vehicle.country : vehicleNew.country,
          });
          alert("Payment successful!");
          console.log(res.data);
          navigate("/profile");
        });
    } else {
      alert("Please fill in all required fields.");
    }
  };

  const handleTypeChange = (e) => {
    const { name } = e.target;
    setErrorPhone("");
    setErrorPassport("");
    setErrorId("");
    setEmailError("");
    if (name === "personal") {
      setInEmail(user_personal.email);
      setInId(user_personal.idcardNumber);
      setInPassport(user_personal.passportNumber);
      setInPhone(user_personal.phoneNumber);
    } else if (name === "corporate") {
      setInEmail(user_corporate.email);
      setInId(user_corporate.idcardNumber);
      setInPassport(user_corporate.passportNumber);
      setInPhone(user_corporate.phoneNumber);
    }
    setTypeofUser((prev) => ({
      ...prev,
      type: name === "personal" ? "Personal" : "Corporate",
    }));
  };

  const updateTypeofUser = (key, value) => {
    setTypeofUser((prev) => ({ ...prev, [key]: value }));
  };
  const updateVehicle = (key, value) => {
    setVehicle((prev) => ({ ...prev, [key]: value }));
  };
  const updateVehicleNew = (key, value) => {
    setVehicleNew((prev) => ({ ...prev, [key]: value }));
  };
  const updatePersonal = (key, value) => {
    setUser_Personal((prev) => ({ ...prev, [key]: value }));
  };
  const updateCorporate = (key, value) => {
    setUser_Corporate((prev) => ({ ...prev, [key]: value }));
  };
  const updateTravel = (key, value) => {
    setTravel((prev) => ({ ...prev, [key]: value }));
  };
  const updateCreditCard = (key, value) => {
    setCreditCard((prev) => ({ ...prev, [key]: value }));
  };

  const handleScroll = () => {
    const scrollElement = scrollRef.current;
    if (scrollElement) {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;
      const totalScrollable = scrollHeight - clientHeight;
      const currentScroll = scrollTop;
      const percentScrolled = (currentScroll / totalScrollable) * 100;
      setScrollPercent(Math.round(percentScrolled));
      const sections = [
        "TYPE OF USER",
        "VEHICLE INFORMATION",
        "PERSONAL INFORMATION",
        "CORPORATE INFORMATION",
        "STABILITY",
        "PASSENGERS INFORMATION",
        "PAYMENT",
      ];

      let found = false;

      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          const scrollPosition = scrollElement.scrollTop;

          const sectionTop = section.offsetTop;
          const sectionHeight = section.offsetHeight;
          const section10Position = sectionTop + sectionHeight * 0.1;
          if (
            scrollPosition >= section10Position &&
            scrollPosition < sectionTop + sectionHeight &&
            !found
          ) {
            setCurrentText(`${id}`);
            found = true;
          }
        }
      });
    }
  };

  useEffect(() => {
    if (changevehicle === "NO" && vehicle.brands !== "") {
      axios
        .get(`${apiUrl}/models/${vehicle.brands}`)
        .then((res) => {
          console.log(res.data);
          setModels(res.data);
        })
        .catch((error) => console.error("Error fetching models:", error));
    } else if (changevehicle === "YES" && vehicleNew.brands !== "") {
      axios
        .get(`${apiUrl}/models/${vehicleNew.brands}`)
        .then((res) => {
          console.log(res.data);
          setModels(res.data);
        })
        .catch((error) => console.error("Error fetching models:", error));
    }
  }, [vehicle.brands, vehicleNew.brands, changevehicle]);
  useEffect(() => {
    if (isFetching || !user || !newUser) {
      return console.log("Finding user...");
    } else {
      const isVehEmpty = (obj) =>
        Object.values(obj).every((value) => value === "");
      if (
        isVehEmpty(user_personal) &&
        isVehEmpty(user_corporate) &&
        isVehEmpty(vehicle)
      ) {
        axios
          .post(`${apiUrl}/getuserpersonal`, {
            user_id: user?.id,
          })
          .then((res) => {
            if (res.status === 200) {
              console.log(res.data[0]);
              const userData = res.data[0];
              setUser_Personal({
                title: userData.title || "",
                firstName: userData.firstname || "",
                lastName: userData.lastname || "",
                idcardNumber: userData.idcardnumber || "",
                passportNumber: userData.passportnumber || "",
                nationality: userData.nationality || "",
                birthDate: userData.dateofbirth || "",
                countryCode: userData.countrycode || "",
                phoneNumber: userData.phonenumber || "",
                email: userData.email || "",
                address: userData.address || "",
                city: userData.city || "",
                zipCode: userData.zipcode || "",
              });
              setInEmail(userData.email);
              setInId(userData.idcardnumber);
              setInPassport(userData.passportnumber);
              setInPhone(userData.phonenumber);
            }
          });
        axios
          .post(`${apiUrl}/getusercorperate`, {
            user_id: user?.id,
          })
          .then((res) => {
            if (res.status === 200) {
              const userData = res.data[0];
              console.log(res.data[0]);
              setUser_Corporate({
                companyName: userData.companyname || "",
                companyAddress: userData.companyaddress || "",
                title: userData.title || "",
                firstName: userData.firstname || "",
                lastName: userData.lastname || "",
                idcardNumber: userData.idcardnumber || "",
                passportNumber: userData.passportnumber || "",
                nationality: userData.nationality || "",
                birthDate: userData.dateofbirth || "",
                countryCode: userData.countrycode || "",
                phoneNumber: userData.phonenumber || "",
                email: userData.email || "",
                address: userData.address || "",
                city: userData.city || "",
                zipCode: userData.zipcode || "",
              });
            }
          });
        axios
          .post(`${apiUrl}/getvehicle`, {
            user_id: user?.id,
          })
          .then((res) => {
            if (res.status === 200) {
              const userData = res.data[0];
              console.log(res.data[0]);
              setVehicle({
                years: userData.year || "",
                brands: userData.brand || "",
                model: userData.model || "",
                color: userData.color || "",
                VIN: userData.vin || "",
                engineNumber: userData.enginenumber || "",
                numberPlate: userData.numberplate || "",
                country: userData.country || "",
              });
            }
          });
      }
    }
  }, [user]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countryRes = await axios.get(`${apiUrl}/country`);
        console.log(countryRes.data);
        const uniqueDials = [];
        countryRes.data.forEach((item) => {
          if (!uniqueDials.some((d) => d.dial === item.dial)) {
            uniqueDials.push({
              dial: item.dial,
              phone: item.phone,
              // id: item.idcard,
              // passport: item.passport,
            });
          }
        });
        setInfoCountry(uniqueDials);
        console.log(uniqueDials);
        const options = uniqueDials.map((item) => ({
          label: item.dial,
          value: item.dial,
        }));
        setDial(options);
        console.log(options);
        const country = [
          ...new Set(countryRes.data.map((item) => item.country)),
        ];
        setCountries(country);
        console.log(country);

        const brandRes = await axios.get(`${apiUrl}/brand`);
        console.log(brandRes.data);
        setBrands(brandRes.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []);
  const openPopup = () => {
    if (changevehicle === "NO") {
      setCar(vehicle);
    } else if (changevehicle === "YES") {
      setCar(vehicleNew);
    }
    const isComplete = (obj) =>
      Object.values(obj).every((value) => value !== "");
    const isAllFieldsFilled = passengers.every((passenger) =>
      Object.values(passenger).every((value) => value.trim() !== "")
    );
    const isNotError = error.every((err) =>
      Object.values(err).every((value) => value.trim() === "")
    );
    if (pkg !== "ta" && typeofuser.type === "Corporate") {
      console.log("corporate");
      console.log(typeofuser);
      console.log(user_corporate);
      console.log(car);
      console.log(travel);
      console.log(passengers);
      if (
        isComplete(typeofuser) &&
        isComplete(user_corporate) &&
        isComplete(vehicle) &&
        isComplete(travel) &&
        isAllFieldsFilled &&
        errorId === "" &&
        errorPhone === "" &&
        errorPassport === "" &&
        emailError === "" &&
        isNotError
      ) {
        setPopup(true);
        setIsFormComplete(true);
      } else {
        setPopup(false);
        setIsFormComplete(false);
      }
    } else if (pkg !== "ta" && typeofuser.type === "Personal") {
      console.log("personal");
      console.log(typeofuser);
      console.log(user_personal);
      console.log(car);
      console.log(travel);
      console.log(passengers);
      if (
        isComplete(typeofuser) &&
        isComplete(user_personal) &&
        isComplete(vehicle) &&
        isComplete(travel) &&
        isAllFieldsFilled &&
        errorId === "" &&
        errorPhone === "" &&
        errorPassport === "" &&
        emailError === "" &&
        isNotError
      ) {
        setPopup(true);
        setIsFormComplete(true);
      } else {
        setPopup(false);
        setIsFormComplete(false);
      }
    }
  };

  useEffect(() => {
    if (pkg === "ta") {
      if (typeofuser.period === "") {
        setPrice(67);
      } else {
        axios
          .post(`${apiUrl}/price`, {
            product: "TA",
            cartype: "",
            period: typeofuser.period,
          })
          .then((res) => {
            if (res.status === 200) {
              console.log(res.data[0].price);
              setPrice(res.data[0].price);
            }
          });
      }
    } else {
      if (typeofuser.period === "" || typeofuser.carType === "") {
        if (pkg === "silver") {
          setPrice(30);
        } else if (pkg === "gold") {
          setPrice(195);
        } else if (pkg === "ruby") {
          setPrice(120);
        }
      } else {
        axios
          .post(`${apiUrl}/price`, {
            product: typeofuser.product,
            cartype: typeofuser.carType,
            period: typeofuser.period,
          })
          .then((res) => {
            if (res.status === 200) {
              console.log(res.data[0].price);
              setPrice(res.data[0].price);
            }
          });
      }
    }
  }, [typeofuser.product, typeofuser.carType, typeofuser.period]);

  const styleSelect = {
    control: (base) => ({
      ...base,
      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
      border: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0px",
      paddingRight: "4px",
    }),
    option: (provided) => ({
      ...provided,
      textTransform: "none",
    }),
  };

  const handlePassengerChange = (index, field, value) => {
    const updatedPassengers = [...passengers];
    updatedPassengers[index][field] = value;
    setPassengers(updatedPassengers);
  };
  const handleId = (index, field, value) => {
    const updateId = [...error];
    updateId[index][field] = value;
    setError(updateId);
  };

  const handleNumberPassengerChange = (e) => {
    const newValue = Math.max(1, parseInt(e.target.value, 10));
    updateTravel("numberPassenger", newValue);
    setPassengers(
      Array.from({ length: newValue }).map((_, index) => ({
        firstName: "",
        lastName: "",
        age: "",
        nationality: "",
        idCardNumber: "",
      }))
    );
    setError(
      Array.from({ length: newValue }).map((_, index) => ({
        errorId: "",
      }))
    );
  };

  useEffect(() => {
    console.log("passenger updated:", passengers);
  }, [passengers]);
  useEffect(() => {
    console.log("card updated:", creditCard);
  }, [creditCard]);

  // useEffect(() => {
  //   const scrollElement = scrollRef.current;
  //   if (scrollElement) {
  //     scrollElement.addEventListener("scroll", handleScroll);
  //     return () => {
  //       scrollElement.removeEventListener("scroll", handleScroll);
  //     };
  //   }
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollRef.current;
      if (!container) return;

      const containerTop = container.offsetTop;
      const containerHeight = container.offsetHeight;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // ตรวจว่าผู้ใช้เลื่อนอยู่ใน container หรือยัง
      if (
        scrollY >= containerTop &&
        scrollY <= containerTop + containerHeight - windowHeight
      ) {
        const percent =
          ((scrollY - containerTop) / (containerHeight - windowHeight)) * 100;
        setScrollPercent(Math.min(100, Math.max(0, Math.round(percent))));
      } else if (scrollY < containerTop) {
        setScrollPercent(0);
      } else if (scrollY > containerTop + containerHeight - windowHeight) {
        setScrollPercent(100);
      }

      // handle fix bar
      const barShouldStick =
        scrollY >= containerTop &&
        scrollY < containerTop + containerHeight - windowHeight;
      setBarSticky(barShouldStick);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const product =
      pkg === "silver"
        ? "Silver Package"
        : pkg === "gold"
        ? "Gold Package"
        : pkg === "ruby"
        ? "Ruby Package"
        : "Comprehensive Thailand Auto Pass Document Premium Set";
    updateTypeofUser("product", product);
    if (pkg === "ta") {
      updateTypeofUser("numberPassenger", 0);
    }
  }, [pkg]);

  return (
    <div className="overflow-x-hidden">
      {pdpa && (
        <div className="fixed inset-0 w-screen h-auto min-h-screen bg-black bg-opacity-50 z-40 overflow-auto">
          <div className="flex justify-center w-full h-auto">
            <div className="relative w-[90vw] h-auto mt-32 mb-16 bg-white rounded-[150px] font-poppins">
              <div className="px-32 py-10 text-sm whitespace-pre-line space-y-2">
                <div className="text-center text-xl font-bold">
                  Privacy Policy{" "}
                </div>
                <div>
                  Tipscrossborder.com (“the Company” or “we”) values the
                  protection of our customers' and service users' personal data
                  in accordance with the Personal Data Protection Act (PDPA). To
                  prevent unauthorized disclosure or misuse of your personal
                  information, we have created this Privacy Policy to help you
                  understand how and why we collect, use, disclose, and store
                  your personal data.{" "}
                </div>
                <div>
                  <div className="font-semibold">
                    1. Collection of Personal Data
                  </div>
                  {
                    "Tipscrossborder.com. may collect your personal data through the following methods:\n\u00a0\u00a0\u00a0\u00a0- By filling out online forms on the Company’s website\n\u00a0\u00a0\u00a0\u00a0- Through direct contact when purchasing insurance policies at the Company’s office\nThe personal data we may collect includes:\n- Full name\n- Address\n- Telephone number \n- Email address \n- Website usage information (e.g., IP address,cookies data) "
                  }
                </div>
                <div>
                  <div className="font-semibold">
                    2. Purpose of Collecting and Using Personal Data
                  </div>
                  {
                    "Your personal data will be used for the following purposes: \n-	To offer insurance policies that suit your needs\n-	To provide coordination and additional information about our products or services\n-	To improve the website and customer experience\n-	For marketing analysis and advertising related to insurance products\n-	To comply with legal requirements and relevant regulations"
                  }
                </div>
                <div>
                  <div className="font-semibold">
                    3. Security of Personal Data
                  </div>
                  The Company employs appropriate security measures to protect
                  your personal data, storing it in encrypted databases to
                  prevent unauthorized access. We also continuously update our
                  security practices to align with the level of risk involved.
                </div>
                <div>
                  <div className="font-semibold">
                    4. Disclosure of Personal Data
                  </div>
                  {
                    "The Company will not disclose your personal data to third parties, except in the following circumstances:\n-	To fulfill your service requests, such as forwarding data to insurance providers\n-	To comply with legal obligations or court orders\n-	When you have given consent for your data to be shared with third parties"
                  }
                </div>
                <div>
                  <div className="font-semibold">
                    5. Your Rights as a Data Subject
                  </div>
                  {
                    "You have the right to:\n-	Request access to and obtain a copy of your personal data held by the Company\n-	Request corrections to any inaccurate personal data\n-	Request the deletion or destruction of your data when it is no longer needed for its original purpose\n-	Request to restrict the use of your personal data if the processing is not aligned with the original consent\nYou may contact the Company through the contact details below to exercise these rights."
                  }
                </div>
                <div>
                  <div className="font-semibold">
                    6. Updates to the Privacy Policy
                  </div>
                  The Company may revise or update this Privacy Policy from time
                  to time to comply with legal requirements or changes in our
                  operations. We encourage you to review this policy regularly
                  for the latest updates.
                </div>
                <div className="relative flex justify-end px-24 mb-6">
                  <button
                    className={"text-white px-6 py-2 rounded-lg bg-[#0F2C59]"}
                    onClick={() => setPdpa(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div className="fixed inset-0 w-screen h-auto min-h-screen bg-black bg-opacity-50 z-40 overflow-auto">
          <div className="flex justify-center w-full h-auto">
            <div className="relative w-[90vw] h-auto mt-32 mb-16 bg-white rounded-[150px] font-poppins">
              <img
                src={`/${pkg}.png`}
                className="w-[20vh] h-[20vh] object-cover z-20 absolute left-1/2 -translate-x-1/2 top-[-14vh]"
                alt=""
              />
              <div className="relative w-[23vw] h-[12vh] -inset-y-8 z-0 left-1/2 -translate-x-1/2">
                <img
                  src={`/${pkg}_bg.png`}
                  alt=""
                  className="w-full h-full rounded-2xl object-cover"
                  style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
                />
                <div className="absolute inset-0 flex items-center justify-center z-10 mt-4">
                  {pkg === "silver" ? (
                    <div className="relative z-20">
                      <StrokedText
                        className="relative font-bold text-2xl left-1/2 -translate-x-1/2"
                        fill="#474747"
                        stroke="#DEDEE0"
                        strokeWidth={4}
                      >
                        Silver Package : Preview
                      </StrokedText>
                    </div>
                  ) : pkg === "gold" ? (
                    <div className="relative z-20">
                      <StrokedText
                        className="relative font-bold text-2xl left-1/2 -translate-x-1/2"
                        fill="#F6F6F6"
                        stroke="#C8A53D"
                        strokeWidth={4}
                      >
                        Gold Package : Preview
                      </StrokedText>
                    </div>
                  ) : (
                    <div className="relative z-20">
                      <StrokedText
                        className="relative font-bold text-3xl left-1/2 -translate-x-1/2"
                        fill="#F6F6F6"
                        stroke="#940709"
                        strokeWidth={4}
                      >
                        Ruby Package : Preview
                      </StrokedText>
                    </div>
                  )}
                </div>
                <div
                  className="absolute inset-0 rounded-2xl"
                  style={{
                    background:
                      pkg === "silver"
                        ? "linear-gradient(to bottom, rgba(255, 255, 255, 0.2) 0%, rgba(251, 251, 251, 0.5) 50%, rgba(222, 222, 224,0.8) 100%)"
                        : pkg === "gold"
                        ? "linear-gradient(to bottom, rgba(138, 111, 23, 0.2) 0%, rgba(138, 111, 23, 0.5) 50%, rgba(200, 165, 61,0.8) 100%)"
                        : pkg === "ruby"
                        ? "linear-gradient(to bottom, rgba(82, 12, 13, 0.2) 0%, rgba(82, 12, 13, 0.5) 50%, rgba(82, 12, 13,0.8) 100%)"
                        : "linear-gradient(to bottom, rgba(15, 44, 89, 0.2) 0%, rgba(15, 44, 89, 0.5) 50%, rgba(15, 44, 89,0.8) 100%)",
                  }}
                />
              </div>
              <div className="grid grid-cols-3 gap-6  pt-6 mx-32 text-sm leading-7">
                {/* Personal Information */}
                <div
                  className={`border-r-2 pl-2 ${
                    pkg === "silver"
                      ? "border-[#474747]"
                      : pkg === "gold"
                      ? "border-[#C8A53D]"
                      : "border-[#940709]"
                  }`}
                >
                  <h2 className="font-bold text-lg pb-2 mb-2">
                    <StrokedText
                      className="relative font-bold text-base tracking-wider"
                      fill={pkg === "silver" ? "#474747" : "#F6F6F6"}
                      stroke={
                        pkg === "silver"
                          ? "#DEDEE0"
                          : pkg === "gold"
                          ? "#C8A53D"
                          : "#940709"
                      }
                      strokeWidth={4}
                    >
                      {typeofuser.type === "Personal"
                        ? "Personal Information"
                        : "Corporate Information"}
                    </StrokedText>
                  </h2>
                  {typeofuser.type === "Corporate" && (
                    <>
                      <p className="flex gap-x-1">
                        <div className="font-semibold">Company Name:</div>
                        <div className="font-medium">
                          {user_corporate.companyName}
                        </div>
                      </p>
                      <p className="flex gap-x-1">
                        <div className="font-semibold">Company Address:</div>
                        <div className="font-medium">
                          {user_corporate.companyAddress}
                        </div>
                      </p>
                    </>
                  )}
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Title:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.title
                        : user_corporate.title}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">First Name:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.firstName
                        : user_corporate.firstName}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Last Name:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.lastName
                        : user_corporate.lastName}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">ID Card Number:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.idcardNumber
                        : user_corporate.idcardNumber}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Passport Number:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.passportNumber
                        : user_corporate.passportNumber}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Nationality:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.nationality
                        : user_corporate.nationality}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Date of Birth:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.birthDate
                        : user_corporate.birthDate}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Tel:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.countryCode +
                          " " +
                          user_personal.phoneNumber
                        : user_corporate.countryCode +
                          " " +
                          user_corporate.phoneNumber}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Email:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.email
                        : user_corporate.email}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Address:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.address
                        : user_corporate.address}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">City:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.city
                        : user_corporate.city}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Zip Code:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.zipCode
                        : user_corporate.zipCode}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">To Province:</div>
                    <div className="font-medium">
                      {typeofuser.type === "Personal"
                        ? user_personal.province
                        : user_corporate.province}
                    </div>
                  </p>
                </div>

                {/* Policy Information */}
                <div
                  className={`border-r-2 pl-2 ${
                    pkg === "silver"
                      ? "border-[#474747]"
                      : pkg === "gold"
                      ? "border-[#C8A53D]"
                      : "border-[#940709]"
                  }`}
                >
                  <h2 className="font-bold text-lg pb-2 mb-2">
                    <StrokedText
                      className="relative font-bold text-base tracking-wider"
                      fill={pkg === "silver" ? "#474747" : "#F6F6F6"}
                      stroke={
                        pkg === "silver"
                          ? "#DEDEE0"
                          : pkg === "gold"
                          ? "#C8A53D"
                          : "#940709"
                      }
                      strokeWidth={4}
                    >
                      Policy Information
                    </StrokedText>
                  </h2>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Policy Type: </div>
                    <div className="font-medium"> {typeofuser.product}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Vehicle Type:</div>
                    <div className="font-medium">{typeofuser.carType}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">
                      Number of Days Since Policy Purchase:
                    </div>
                    <div className="font-medium">{typeofuser.period}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Vehicle Year:</div>
                    <div className="font-medium">
                      {changevehicle === "NO"
                        ? vehicle.years
                        : vehicleNew.years}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Brand:</div>
                    <div className="font-medium">
                      {changevehicle === "NO"
                        ? vehicle.brands
                        : vehicleNew.brands}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Car Model:</div>
                    <div className="font-medium">
                      {changevehicle === "NO"
                        ? vehicle.model
                        : vehicleNew.model}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Color:</div>
                    <div className="font-medium">
                      {changevehicle === "NO"
                        ? vehicle.color
                        : vehicleNew.color}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">
                      Vehicle Identification Number:
                    </div>
                    <div className="font-medium">
                      {changevehicle === "NO" ? vehicle.VIN : vehicleNew.VIN}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Engine Number:</div>
                    <div className="font-medium">
                      {changevehicle === "NO"
                        ? vehicle.engineNumber
                        : vehicleNew.engineNumber}
                    </div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Number Plate:</div>
                    <div className="font-medium">
                      {changevehicle === "NO"
                        ? vehicle.numberPlate
                        : vehicleNew.numberPlate}
                    </div>
                  </p>
                </div>

                {/* Immigration Information */}
                <div className="pl-2">
                  <h2 className="font-bold text-lg pb-2 mb-2">
                    <StrokedText
                      className="relative font-bold text-base tracking-wider"
                      fill={pkg === "silver" ? "#474747" : "#F6F6F6"}
                      stroke={
                        pkg === "silver"
                          ? "#DEDEE0"
                          : pkg === "gold"
                          ? "#C8A53D"
                          : "#940709"
                      }
                      strokeWidth={4}
                    >
                      Immigration Information
                    </StrokedText>
                  </h2>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Departure Date:</div>
                    <div className="font-medium">{travel.travelStart}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Return Date:</div>
                    <div className="font-medium">{travel.returnDate}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">
                      Departure port (Malaysia):
                    </div>
                    <div className="font-medium">{travel.departurePort}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Arrival Port:</div>
                    <div className="font-medium">{travel.arrivalPort}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Days in Thailand:</div>
                    <div className="font-medium">{calculateDays()}</div>
                  </p>
                  <p className="flex gap-x-1">
                    <div className="font-semibold">Number of Passengers:</div>
                    <div className="font-medium">{travel.numberPassenger}</div>
                  </p>
                </div>
              </div>

              {/* Passenger Information Table */}
              <div className="relative mt-6 w-[30vw] left-1/2 -translate-x-1/2">
                <h2 className="flex font-bold text-lg pb-2 mb-2 justify-center">
                  <StrokedText
                    className="relative font-bold text-base tracking-wider"
                    fill={pkg === "silver" ? "#474747" : "#F6F6F6"}
                    stroke={
                      pkg === "silver"
                        ? "#DEDEE0"
                        : pkg === "gold"
                        ? "#C8A53D"
                        : "#940709"
                    }
                    strokeWidth={4}
                  >
                    Passenger Immigration Information
                  </StrokedText>
                </h2>
                <table
                  className={`w-full outline rounded-3xl overflow-hidden text-sm font-semibold outline-offset-[-2px] ${
                    pkg === "silver"
                      ? "outline-[#474747]"
                      : pkg === "gold"
                      ? "outline-[#C8A53D]"
                      : "outline-[#940709]"
                  }`}
                >
                  <thead className="bg-[#C8A53D] text-white">
                    <tr>
                      <th className="p-2 text-center">No.</th>
                      <th className="p-2 text-center">Name</th>
                      <th className="p-2 text-center">Age</th>
                      <th className="p-2 text-center">Nationality</th>
                    </tr>
                  </thead>
                  <tbody>
                    {passengers.map((passenger, index) => (
                      <tr
                        key={index}
                        className=" text-center  text-xs rounded-3xl"
                      >
                        <td className="p-2 ">{index + 1}</td>
                        <td
                          className={`p-2 border-x-2 ${
                            pkg === "silver"
                              ? "border-[#474747]"
                              : pkg === "gold"
                              ? "border-[#C8A53D]"
                              : "border-[#940709]"
                          }`}
                        >
                          {passenger.firstName + passenger.lastName}
                        </td>
                        <td
                          className={`p-2 border-x-2 ${
                            pkg === "silver"
                              ? "border-[#474747]"
                              : pkg === "gold"
                              ? "border-[#C8A53D]"
                              : "border-[#940709]"
                          }`}
                        >
                          {passenger.age}
                        </td>
                        <td
                          className={`p-2 border-x-2 ${
                            pkg === "silver"
                              ? "border-[#474747]"
                              : pkg === "gold"
                              ? "border-[#C8A53D]"
                              : "border-[#940709]"
                          }`}
                        >
                          {passenger.nationality}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Close Button */}
              <div className="relative top-[-40px] flex justify-end px-32 mb-6">
                <button
                  className={`text-white px-6 py-2 rounded-lg ${
                    pkg === "silver"
                      ? "bg-[#474747] hover:bg-[#393939]"
                      : pkg === "gold"
                      ? "bg-[#C8A53D] hover:bg-[#b99939]"
                      : "bg-[#940709] hover:bg-[#840709]"
                  }`}
                  onClick={() => setPopup(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <NavBar />
      <div className="relative w-full bg-[#EEEEEE] font-poppins text-black">
        <div
          className="w-full h-[35vh] bg-[#FFFFFF50] flex flex-col items-center absolute z-10  backdrop-blur-[27.8px]"
          style={{ filter: "drop-shadow(0px 3px 14.1px rgba(0, 0, 0, 0.25))" }}
        >
          <img
            src={`/${pkg}.png`}
            className="w-[17vh] h-[17vh] object-cover z-20 relative "
            alt=""
          />
          <div className="relative w-[65vw] h-[18vh] -inset-y-16 z-0">
            <img
              src={`/${pkg}_bg.png`}
              alt=""
              className="w-full h-full rounded-2xl object-cover"
              style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
            />
            <div className="absolute inset-0 flex items-center justify-center z-10 mt-4">
              {pkg === "silver" ? (
                <div className="relative z-20">
                  <StrokedText
                    className="relative font-bold text-3xl left-1/2 -translate-x-1/2"
                    fill="#474747"
                    stroke="#DEDEE0"
                    strokeWidth={4}
                  >
                    Silver Package
                  </StrokedText>
                  <StrokedText
                    className="relative font-medium text-sm tracking-widest left-1/2 -translate-x-1/2"
                    fill="#474747"
                    stroke="#DEDEE0"
                    strokeWidth={2}
                  >
                    Include Compulsory + TA
                  </StrokedText>
                </div>
              ) : pkg === "gold" ? (
                <div className="relative z-20">
                  <StrokedText
                    className="relative font-bold text-3xl left-1/2 -translate-x-1/2"
                    fill="#F6F6F6"
                    stroke="#C8A53D"
                    strokeWidth={4}
                  >
                    Gold Package
                  </StrokedText>
                  <StrokedText
                    className="relative font-medium text-sm tracking-widest left-1/2 -translate-x-1/2"
                    fill="#F6F6F6"
                    stroke="#C8A53D"
                    strokeWidth={2}
                  >
                    Include Compulsory + TA + Voluntary Insurance 3+
                  </StrokedText>
                </div>
              ) : pkg === "ruby" ? (
                <div className="relative z-20">
                  <StrokedText
                    className="relative font-bold text-3xl left-1/2 -translate-x-1/2"
                    fill="#F6F6F6"
                    stroke="#940709"
                    strokeWidth={4}
                  >
                    Ruby Package
                  </StrokedText>
                  <StrokedText
                    className="relative font-medium text-sm tracking-widest left-1/2 -translate-x-1/2"
                    fill="#F6F6F6"
                    stroke="#940709"
                    strokeWidth={2}
                  >
                    Include Compulsory + TA + Voluntary Insurance
                  </StrokedText>
                </div>
              ) : (
                <h2 className="text-center text-2xl font-bold text-[#D9D9D9]">
                  Comprehensive Thailand Auto Pass Document{" "}
                  <span className="text-[#FCEA8F]">Premium</span>
                </h2>
              )}
            </div>
            <div
              className="absolute inset-0 rounded-2xl"
              style={{
                background:
                  pkg === "silver"
                    ? "linear-gradient(to bottom, rgba(255, 255, 255, 0.2) 0%, rgba(251, 251, 251, 0.5) 50%, rgba(222, 222, 224,0.8) 100%)"
                    : pkg === "gold"
                    ? "linear-gradient(to bottom, rgba(138, 111, 23, 0.2) 0%, rgba(138, 111, 23, 0.5) 50%, rgba(200, 165, 61,0.8) 100%)"
                    : pkg === "ruby"
                    ? "linear-gradient(to bottom, rgba(82, 12, 13, 0.2) 0%, rgba(82, 12, 13, 0.5) 50%, rgba(82, 12, 13,0.8) 100%)"
                    : "linear-gradient(to bottom, rgba(15, 44, 89, 0.2) 0%, rgba(15, 44, 89, 0.5) 50%, rgba(15, 44, 89,0.8) 100%)",
              }}
            />
          </div>
        </div>
        <div
          className={`${
            barSticky ? "fixed top-[5vh]" : "absolute top-[30vh]"
          } left-1/2 transform -translate-x-1/2 w-[30vw] h-8 flex items-center justify-center z-20 transition-all duration-300`}
        >
          <div className="w-full h-4 rounded-full bg-gray-300 relative overflow-hidden shadow-lg">
            <div
              className="h-full bg-[#0F2C59] rounded-full transition-all"
              style={{
                width: `${scrollPercent}%`,
                backgroundImage: `url(/${pkg}_bg.png)`,
                backgroundSize: "cover",
                backgroundPosition: `${scrollPercent}%`,
                color: "transparent",
                opacity: 0.7,
              }}
            />
          </div>
          <span
            className={`absolute text-sm font-normal ${
              pkg === "gold" ? "text-[#520C0D]" : "text-[#0F2C59]"
            } uppercase bottom-6 font-bree`}
          >
            {currentText}
          </span>
        </div>
        <div
          className="relative w-[65vw+0.5rem] h-auto left-[5vw] pt-12z-0 "
          ref={scrollRef}
        >
          <div className="relative w-full h-[35vh] bg-transparent" />
          <div
            className="relative w-[65vw] h-auto mx-1 rounded-lg overflow-hidden mt-10"
            style={{
              background:
                "linear-gradient(50deg, #CDCDCD 0%, #9B9B9B 19%, #A2A2A2 24%, #AEAEAE 29%, #BCBCBC 52%, #D9D9D9 83%, #E9E9E9 100%)",
              boxShadow:
                "inset 7px 7px 4px rgba(255, 255, 255, 0.7), inset -7px -7px 4px rgba(0, 0, 0, 0.25)",
              filter:
                "drop-shadow(-1px -1px 4px rgba(0, 0, 0, 0.25)) drop-shadow(9px 9px 9px rgba(0, 0, 0, 0.2))",
            }}
          >
            <form className="uppercase py-10 text-base">
              {/* Product and Car Type */}
              <div id="TYPE OF USER" className="space-y-1 px-10">
                <div className="flex gap-10 pt-4">
                  <div className="w-full">
                    <label htmlFor="product" className="block font-medium pt-2">
                      Product
                    </label>
                    <Select
                      options={[
                        {
                          value: "Gold Package",
                          label: "Gold Package",
                        },
                        {
                          value: "Silver Package",
                          label: "Silver Package",
                        },
                        {
                          value: "Ruby Package",
                          label: "Ruby Package",
                        },
                        {
                          value: "TA",
                          label:
                            "Comprehensive Thailand Auto Pass Document Premium Set",
                        },
                      ]}
                      className="w-full border-none rounded-md text-center font-light"
                      styles={styleSelect}
                      value={
                        typeofuser.product
                          ? {
                              value: typeofuser.product,
                              label: typeofuser.product,
                            }
                          : null
                      }
                      onChange={(option) => {
                        const product =
                          option.value === "Gold Package"
                            ? "gold"
                            : option.value === "Silver Package"
                            ? "silver"
                            : option.value === "Ruby Package"
                            ? "ruby"
                            : "ta";
                        navigate(`/info?pkg=${product}`);
                        window.location.reload();
                      }}
                      placeholder="PRODUCT"
                      isSearchable={false}
                    />
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="car-type"
                      className="block font-medium pt-2"
                    >
                      Car Type
                    </label>
                    <Select
                      options={[
                        {
                          value: "SEDAN / MPV / SUV 7 seats or below",
                          label: "SEDAN / MPV / SUV 7 seats or below",
                        },
                        {
                          value: "MINI – VAN / MPV 7-15 seats",
                          label: "MINI – VAN / MPV 7-15 seats",
                        },
                        {
                          value: "4x4 Pick-Up Truck 3-5 seats",
                          label: "4x4 Pick-Up Truck 3-5 seats",
                        },
                      ]}
                      className="w-full border-none rounded-md text-center font-light"
                      styles={styleSelect}
                      value={
                        typeofuser.carType
                          ? {
                              value: typeofuser.carType,
                              label: typeofuser.carType,
                            }
                          : null
                      }
                      onChange={(option) => {
                        updateTypeofUser("carType", option.value);
                        openPopup();
                      }}
                      placeholder="CAR TYPE"
                      isSearchable={false}
                    />
                  </div>
                </div>
              </div>

              {/* Period */}
              <div
                id="TYPE OF USER"
                className="space-y-1 text-center bg px-10 mt-6 py-2"
                style={{
                  background:
                    "linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0.5) 75%, rgba(255, 255, 255, 0) 100%)",
                  filter: "drop-shadow(0px 3px 21.3px rgba(0, 0, 0, 0.1))",
                }}
              >
                <label className=" font-medium">Period</label>
                <div className="flex gap-4 items-center justify-center font-medium text-[#BC0000] pb-2">
                  {["7 DAYS", "15 DAYS", "30 DAYS"].map((item) => (
                    <button
                      key={item}
                      type="button"
                      className={`py-2 px-4 rounded-[44px] ${
                        typeofuser.period === item
                          ? "bg-slate-300"
                          : "bg-white hover:bg-gray-400"
                      }`}
                      style={{
                        boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                      }}
                      onClick={() => {
                        updateTypeofUser("period", item);
                        openPopup();
                      }}
                    >
                      {item}
                    </button>
                  ))}
                  {pkg === "ta" && (
                    <button
                      key={"90 DAYS"}
                      type="button"
                      className={`py-2 px-4 rounded-[44px] ${
                        typeofuser.period === "90 DAYS"
                          ? "bg-slate-300"
                          : "bg-white hover:bg-gray-400"
                      }`}
                      style={{
                        boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                      }}
                      onClick={() => {
                        updateTypeofUser("period", "90 DAYS");
                        openPopup();
                      }}
                    >
                      {"90 DAYS"}
                    </button>
                  )}
                </div>
              </div>

              {/* Personal or Corporate */}
              <div id="TYPE OF USER" className="space-y-1">
                <div className="flex gap-10 justify-center px-10 pt-6 pb-10">
                  <label className="flex items-center space-x-2 text-center font-medium">
                    <input
                      type="checkbox"
                      name="personal"
                      checked={typeofuser.type === "Personal"}
                      onChange={handleTypeChange}
                      className="mx-2 placeholder-[#808080]"
                      style={{
                        boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                      }}
                    />
                    Personal
                  </label>
                  <label className="flex items-center space-x-2 font-medium">
                    <input
                      type="checkbox"
                      name="corporate"
                      checked={typeofuser.type === "Corporate"}
                      onChange={handleTypeChange}
                      className="mx-2 placeholder-[#808080]"
                      style={{
                        boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                      }}
                    />
                    Corporate
                  </label>
                </div>
              </div>

              {/* Vehicle Information */}
              {pkg !== "ta" && (
                <div id="VEHICLE INFORMATION" className="space-y-1 py-10">
                  <h2 className="text-center font-semibold text-2xl">
                    Vehicle Information
                  </h2>
                  <div className="space-y-1">
                    <div
                      className="flex flex-col text-center pt-4 pb-3 justify-center items-center"
                      style={{
                        background:
                          "linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0.5) 75%, rgba(255, 255, 255, 0) 100%)",
                        filter:
                          "drop-shadow(0px 3px 21.3px rgba(0, 0, 0, 0.1))",
                      }}
                    >
                      <label
                        htmlFor="change-vehicle"
                        className="block font-medium text-[#D70000] pb-2 text-lg"
                      >
                        Do you want to change vehicle information?
                      </label>
                      <Select
                        options={[
                          { value: "NO", label: "NO" },
                          { value: "YES", label: "YES" },
                        ]}
                        className="justify-center w-[6vw]  border-none rounded-md text-center font-light "
                        styles={styleSelect}
                        menuPortalTarget={document.body}
                        value={
                          changevehicle
                            ? {
                                value: changevehicle,
                                label: changevehicle,
                              }
                            : {
                                value: "NO",
                                label: "NO",
                              }
                        }
                        onChange={(option) => {
                          console.log(option.value);
                          setChangeVehicle(option.value);
                          console.log(changevehicle);
                        }}
                        isSearchable={false}
                      />
                    </div>
                    <div className="flex gap-10 px-10">
                      <div className="basis-[21%]">
                        <label
                          htmlFor="years"
                          className="block font-medium pt-2"
                        >
                          Years
                        </label>
                        <Select
                          options={Array.from(
                            { length: new Date().getFullYear() - 1995 },
                            (_, i) => ({ value: 1996 + i, label: 1996 + i })
                          )}
                          className="w-full border-none rounded-md text-center font-light"
                          styles={styleSelect}
                          value={
                            changevehicle === "NO"
                              ? vehicle.years
                                ? { value: vehicle.years, label: vehicle.years }
                                : null
                              : vehicleNew.years
                              ? {
                                  value: vehicleNew.years,
                                  label: vehicleNew.years,
                                }
                              : null
                          }
                          onChange={(option) => {
                            if (changevehicle === "NO") {
                              updateVehicle("years", option.value);
                            } else {
                              updateVehicleNew("years", option.value);
                            }
                            openPopup();
                          }}
                          placeholder="YEARS"
                        />
                      </div>
                      <div className="basis-[29%]">
                        <label
                          htmlFor="brands"
                          className="block font-medium pt-2"
                        >
                          Brands
                        </label>
                        <Select
                          options={brands.map((b) => ({ value: b, label: b }))}
                          className="w-full border-none rounded-md text-center font-light"
                          styles={styleSelect}
                          value={
                            changevehicle === "NO"
                              ? vehicle.brands
                                ? {
                                    value: vehicle.brands,
                                    label: vehicle.brands,
                                  }
                                : null
                              : vehicleNew.brands
                              ? {
                                  value: vehicleNew.brands,
                                  label: vehicleNew.brands,
                                }
                              : null
                          }
                          onChange={(option) => {
                            if (changevehicle === "NO") {
                              updateVehicle("brands", option.value);
                              updateVehicle("model", "");
                            } else {
                              updateVehicleNew("brands", option.value);
                              updateVehicleNew("model", "");
                            }
                            openPopup();
                          }}
                          placeholder="BRANDS"
                        />
                      </div>
                      <div className="basis-[31%]">
                        <label
                          htmlFor="model"
                          className="block font-medium pt-2"
                        >
                          Model
                        </label>
                        <Select
                          options={models.map((m) => ({
                            value: m.model,
                            label: m.model,
                          }))}
                          className="w-full border-none rounded-md text-center font-light "
                          styles={styleSelect}
                          value={
                            changevehicle === "NO"
                              ? vehicle.model
                                ? { value: vehicle.model, label: vehicle.model }
                                : null
                              : vehicleNew.model
                              ? {
                                  value: vehicleNew.model,
                                  label: vehicleNew.model,
                                }
                              : null
                          }
                          onChange={(option) => {
                            if (changevehicle === "NO") {
                              updateVehicle("model", option.value);
                            } else {
                              updateVehicleNew("model", option.value);
                            }
                            openPopup();
                          }}
                          placeholder="MODEL"
                        />
                      </div>
                      <div className="basis-[19%]">
                        <label
                          htmlFor="color"
                          className="block font-medium pt-2"
                        >
                          Color
                        </label>
                        <Select
                          options={[
                            { value: "White", label: "White" },
                            { value: "Black", label: "Black" },
                            { value: "Gray", label: "Gray" },
                            { value: "Silver", label: "Silver" },
                            { value: "Red", label: "Red" },
                            { value: "Blue", label: "Blue" },
                            { value: "Yellow", label: "Yellow" },
                            { value: "Green", label: "Green" },
                            { value: "Orange", label: "Orange" },
                            { value: "Purple", label: "Purple" },
                            { value: "Metallic Blue", label: "Metallic Blue" },
                            { value: "Metallic Gray", label: "Metallic Gray" },
                            {
                              value: "Metallic Silver",
                              label: "Metallic Silver",
                            },
                            { value: "Metallic Red", label: "Metallic Red" },
                            { value: "Pearl White", label: "Pearl White" },
                            { value: "Gold", label: "Gold" },
                            { value: "Copper", label: "Copper" },
                            { value: "Matte Colors", label: "Matte Colors" },
                            { value: "Matte Black", label: "Matte Black" },
                            { value: "Matte Gray", label: "Matte Gray" },
                            { value: "Matte Blue", label: "Matte Blue" },
                            { value: "Matte Red", label: "Matte Red" },
                            { value: "Two-Tone", label: "Two-Tone" },
                            { value: "Champagne", label: "Champagne" },
                            { value: "Teal", label: "Teal" },
                            { value: "Turquoise", label: "Turquoise" },
                            { value: "Lavender", label: "Lavender" },
                            { value: "Magenta", label: "Magenta" },
                            { value: "Burgundy", label: "Burgundy" },
                            { value: "Lime Green", label: "Lime Green" },
                            { value: "Rose Gold", label: "Rose Gold" },
                            { value: "Midnight Blue", label: "Midnight Blue" },
                            { value: "Forest Green", label: "Forest Green" },
                            { value: "Electric Blue", label: "Electric Blue" },
                            { value: "Neon Yellow", label: "Neon Yellow" },
                            { value: "Gunmetal Gray", label: "Gunmetal Gray" },
                            {
                              value: "Chocolate Brown",
                              label: "Chocolate Brown",
                            },
                          ]}
                          className="w-full border-none rounded-md text-center font-light "
                          styles={styleSelect}
                          value={
                            changevehicle === "NO"
                              ? vehicle.color
                                ? { value: vehicle.color, label: vehicle.color }
                                : null
                              : vehicleNew.color
                              ? {
                                  value: vehicleNew.color,
                                  label: vehicleNew.color,
                                }
                              : null
                          }
                          onChange={(option) => {
                            if (changevehicle === "NO") {
                              updateVehicle("color", option.value);
                            } else {
                              updateVehicleNew("color", option.value);
                            }
                            openPopup();
                          }}
                          placeholder="COLOR"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-10 px-10">
                    <div className=" basis-[39%]">
                      <label htmlFor="vin" className="block font-medium pt-2">
                        VIN ( Vehicle Identification Number )
                      </label>
                      <input
                        type="text"
                        id="vin"
                        placeholder="VIN"
                        className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={
                          changevehicle === "NO" ? vehicle.VIN : vehicleNew.VIN
                        }
                        onChange={(e) => {
                          if (changevehicle === "NO") {
                            updateVehicle("VIN", e.target.value);
                            updateVehicle("engineNumber", e.target.value);
                          } else {
                            updateVehicleNew("VIN", e.target.value);
                            updateVehicleNew("engineNumber", e.target.value);
                          }
                        }}
                        onBlur={openPopup}
                      />
                    </div>
                    <div className=" basis-[36%]">
                      <label
                        htmlFor="engine-number"
                        className="block font-medium pt-2 text-red-500"
                      >
                        Engine number
                      </label>
                      <div
                        id="engine-number"
                        className={`w-full p-2 border-none rounded-md bg-white text-center font-light text-ellipsis ${
                          changevehicle === "NO"
                            ? vehicle.engineNumber === ""
                              ? "text-[#808080]"
                              : ""
                            : vehicleNew.engineNumber === ""
                            ? "text-[#808080]"
                            : ""
                        }`}
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        {changevehicle === "NO"
                          ? vehicle.engineNumber === ""
                            ? "Engine number"
                            : vehicle.engineNumber
                          : vehicleNew.engineNumber === ""
                          ? "Engine number"
                          : vehicleNew.engineNumber}
                      </div>
                    </div>
                    <div className=" basis-[25%]">
                      <label
                        htmlFor="number-plate"
                        className="block font-medium pt-2"
                      >
                        PLATE NUMBER
                      </label>
                      <input
                        type="text"
                        id="number-plate"
                        placeholder="NUMBER"
                        className="w-full p-2 border-none rounded-md text-center font-light text-ellipsis placeholder-[#808080]"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={
                          changevehicle === "NO"
                            ? vehicle.numberPlate
                            : vehicleNew.numberPlate
                        }
                        onChange={(e) => {
                          if (changevehicle === "NO") {
                            updateVehicle("numberPlate", e.target.value);
                          } else {
                            updateVehicleNew("numberPlate", e.target.value);
                          }
                        }}
                        onBlur={openPopup}
                      />
                    </div>
                  </div>
                  <div className="flex px-10">
                    <div className=" basis-[23%]">
                      <label
                        htmlFor="country"
                        className="block font-medium pt-2"
                      >
                        Country
                      </label>
                      <Select
                        options={countries.map((c) => ({ value: c, label: c }))}
                        className="w-full border-none rounded-md text-center font-light"
                        styles={styleSelect}
                        value={
                          changevehicle === "NO"
                            ? vehicle.country
                              ? {
                                  value: vehicle.country,
                                  label: vehicle.country,
                                }
                              : null
                            : vehicleNew.country
                            ? {
                                value: vehicleNew.country,
                                label: vehicleNew.country,
                              }
                            : null
                        }
                        onChange={(option) => {
                          console.log(option.value);
                          if (changevehicle === "NO") {
                            updateVehicle("country", option.value);
                          } else {
                            updateVehicleNew("country", option.value);
                          }
                          openPopup();
                        }}
                        placeholder="COUNTRY"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Corporate Information */}
              <div
                id={
                  typeofuser.type === "Corporate"
                    ? "CORPORATE INFORMATION"
                    : "PERSONAL INFORMATION"
                }
                className="space-y-1 px-10 pt-10"
              >
                <h2 className="text-center font-semibold text-2xl">
                  {typeofuser.type === "Corporate"
                    ? "Corporate Information"
                    : typeofuser.type === "Personal"
                    ? "Personal  Information"
                    : ""}
                </h2>
                {typeofuser.type === "Corporate" && (
                  <>
                    <div className="flex gap-10">
                      <div className="basis-[42%]">
                        <label
                          htmlFor="company-name"
                          className="block font-medium pt-2"
                        >
                          Company Name
                        </label>
                        <input
                          type="text"
                          id="company-name"
                          placeholder="NAME"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_corporate.companyName}
                          onChange={(e) => {
                            updateCorporate("companyName", e.target.value);
                          }}
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[58%]">
                        <label
                          htmlFor="company-address"
                          className="block font-medium pt-2"
                        >
                          Company Address
                        </label>
                        <input
                          type="text"
                          id="company-address"
                          placeholder="ADDRESS"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_corporate.companyAddress}
                          onChange={(e) => {
                            updateCorporate("companyAddress", e.target.value);
                            openPopup();
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[12%]">
                        <label
                          htmlFor="title"
                          className="block font-medium pt-2"
                        >
                          Title
                        </label>
                        <Select
                          options={[
                            { value: "Mr.", label: "Mr." },
                            { value: "Mrs.", label: "Mrs." },
                            { value: "Ms.", label: "Ms." },
                          ]}
                          className="w-full border-none rounded-md text-center font-light"
                          styles={styleSelect}
                          value={
                            user_corporate.title
                              ? {
                                  value: user_corporate.title,
                                  label: user_corporate.title,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updateCorporate("title", option.value);
                            openPopup();
                          }}
                          placeholder="TITLE"
                          isSearchable={false}
                        />
                      </div>
                      <div className="basis-[44%]">
                        <label
                          htmlFor="first-name"
                          className="block font-medium pt-2"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          id="first-name"
                          placeholder="FIRST NAME"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_corporate.firstName}
                          onChange={(e) =>
                            updateCorporate("firstName", e.target.value)
                          }
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[44%]">
                        <label
                          htmlFor="last-address"
                          className="block font-medium pt-2"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          id="last-address"
                          placeholder="LAST NAME"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_corporate.lastName}
                          onChange={(e) =>
                            updateCorporate("lastName", e.target.value)
                          }
                          onBlur={openPopup}
                        />
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[38%]">
                        <label
                          htmlFor="idcard-number"
                          className="block font-medium pt-2"
                        >
                          id card number
                        </label>
                        <input
                          type="text"
                          id="idcard-number"
                          placeholder="ID CARD"
                          maxlength={16}
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={inId}
                          onChange={(e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            setInId(value);
                          }}
                          onBlur={() => validateId(inId)}
                        />
                        {errorId && (
                          <p className="absolute text-red-500 text-xs ml-2">
                            {errorId}
                          </p>
                        )}
                      </div>
                      <div className="basis-[38%]">
                        <label
                          htmlFor="passport-number"
                          className="block font-medium pt-2"
                        >
                          PASSPORT NUMBER
                        </label>
                        <input
                          type="text"
                          id="passport-number"
                          placeholder="PASSPORT"
                          maxlength={9}
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={inPassport}
                          onChange={(e) => setInPassport(e.target.value)}
                          onBlur={() => validatePassport(inPassport)}
                        />
                        {errorPassport && (
                          <p className="absolute text-red-500 text-xs ml-2">
                            {errorPassport}
                          </p>
                        )}
                      </div>
                      <div className="basis-[24%]">
                        <label
                          htmlFor="nationality"
                          className="block font-medium pt-2"
                        >
                          NATIONALITY
                        </label>
                        <Select
                          options={countries.map((c) => ({
                            value: c,
                            label: c,
                          }))}
                          className="border-none rounded-md text-center font-light "
                          styles={styleSelect}
                          value={
                            user_corporate.nationality
                              ? {
                                  value: user_corporate.nationality,
                                  label: user_corporate.nationality,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updateCorporate("nationality", option.value);
                            openPopup();
                          }}
                          placeholder="NATIONALITY"
                        />
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[18%]">
                        <label
                          htmlFor="date-of-birth"
                          className="block font-medium pt-2"
                        >
                          DATE OF BIRTH
                        </label>
                        <input
                          type="date"
                          id="date-of-birth"
                          className={`w-full p-2 border-none rounded-md text-center font-light ${
                            !user_corporate.birthDate
                              ? "text-[#808080]"
                              : "text-black"
                          }`}
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={
                            user_corporate.birthDate
                              ? user_corporate.birthDate
                              : null
                          }
                          onChange={(e) => {
                            updateCorporate("birthDate", e.target.value);
                            openPopup();
                          }}
                        />
                      </div>
                      <div className="basis-[43%] ">
                        <label
                          htmlFor="phone-number"
                          className="block font-medium pt-2"
                        >
                          Phone number
                        </label>
                        <div className="flex items-center gap-2">
                          <Select
                            options={dial}
                            className="basis-[25%] border-none rounded-md text-center font-light "
                            styles={styleSelect}
                            value={
                              user_corporate.countryCode
                                ? {
                                    value: user_corporate.countryCode,
                                    label: user_corporate.countryCode,
                                  }
                                : null
                            }
                            onChange={(option) => {
                              console.log(option.value);
                              console.log(infoCountry);
                              const filteredPhones = infoCountry.filter(
                                (item) => item.dial === option.value
                              );
                              console.log(filteredPhones);
                              setPhone(filteredPhones[0].phone);

                              // setId(filteredPhones.id);
                              // setPassport(filteredPhones.passport);
                              updateCorporate("countryCode", option.value);
                              updateCorporate("phoneNumber", "");
                              setErrorPhone("");
                              console.log(filteredPhones[0].phone);
                              console.log(phone);
                              setInPhone("");
                            }}
                            placeholder="+66"
                            isSearchable={false}
                          />
                          <div className="flex flex-col basis-[75%] relative">
                            <input
                              type="text"
                              id="phone-number"
                              maxlength={10}
                              placeholder="81 123 4567"
                              className=" p-2 border-none rounded-md  text-center  font-light text-ellipsis placeholder-[#808080]"
                              style={{
                                boxShadow:
                                  "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                              }}
                              value={inPhone}
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, "");
                                setInPhone(value);
                              }}
                              onBlur={() => validatePhone(inPhone)}
                            />
                            {errorPhone && (
                              <p className="absolute top-full text-red-500 text-xs ml-2">
                                {errorPhone}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="basis-[39%]">
                        <label
                          htmlFor="email"
                          className="block font-medium pt-2"
                        >
                          email
                        </label>
                        <input
                          type="email"
                          id="email"
                          placeholder="EMAIL"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={inEmail}
                          onChange={(e) => {
                            setInEmail(e.target.value);
                          }}
                          onBlur={() => validateEmail(inEmail)}
                        />
                        {emailError && (
                          <p className="absolute text-red-500 text-xs ml-2">
                            {emailError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[38%]">
                        <label
                          htmlFor="address"
                          className="block font-medium pt-2"
                        >
                          address
                        </label>
                        <input
                          type="text"
                          id="address"
                          placeholder="ADDRESS"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_corporate.address}
                          onChange={(e) =>
                            updateCorporate("address", e.target.value)
                          }
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[20%]">
                        <label
                          htmlFor="city"
                          className="block font-medium pt-2"
                        >
                          City
                        </label>
                        <Select
                          options={[
                            { value: "Johor", label: "Johor" },
                            { value: "Kedah", label: "Kedah" },
                            { value: "Kelantan", label: "Kelantan" },
                            {
                              value: "Malacca (Melaka)",
                              label: "Malacca (Melaka)",
                            },
                            {
                              value: "Negeri Sembilan",
                              label: "Negeri Sembilan",
                            },
                            { value: "Pahang", label: "Pahang" },
                            {
                              value: "Penang (Pulau Pinang)",
                              label: "Penang (Pulau Pinang)",
                            },
                            { value: "Perak", label: "Perak" },
                            { value: "Perlis", label: "Perlis" },
                            { value: "Sabah", label: "Sabah" },
                            { value: "Sarawak", label: "Sarawak" },
                            { value: "Selangor", label: "Selangor" },
                            { value: "Terengganu", label: "Terengganu" },
                            { value: "Kuala Lumpur", label: "Kuala Lumpur" },
                            { value: "Labuan", label: "Labuan" },
                            { value: "Putrajaya", label: "Putrajaya" },
                          ]}
                          className="w-full border-none rounded-md text-center font-light "
                          styles={styleSelect}
                          value={
                            user_corporate.city
                              ? {
                                  value: user_corporate.city,
                                  label: user_corporate.city,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updateCorporate("city", option.value);
                            openPopup();
                          }}
                          placeholder="CITY"
                        />
                      </div>
                      <div className="basis-[20%]">
                        <label
                          htmlFor="zip-code"
                          className="block font-medium pt-2"
                        >
                          zip code
                        </label>
                        <input
                          type="text"
                          id="zip-code"
                          placeholder="ZIP"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_corporate.zipCode}
                          onChange={(e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            updateCorporate("zipCode", value);
                          }}
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[22%]">
                        <label
                          htmlFor="province"
                          className="block font-medium pt-2"
                        >
                          to province
                        </label>
                        <Select
                          options={[
                            { value: "Ang Thong", label: "Ang Thong" },
                            { value: "Ayutthaya", label: "Ayutthaya" },
                            { value: "Bangkok", label: "Bangkok" },
                            { value: "Chainat", label: "Chainat" },
                            { value: "Lopburi", label: "Lopburi" },
                            { value: "Nakhon Nayok", label: "Nakhon Nayok" },
                            { value: "Nakhon Pathom", label: "Nakhon Pathom" },
                            { value: "Nonthaburi", label: "Nonthaburi" },
                            { value: "Pathum Thani", label: "Pathum Thani" },
                            { value: "Samut Prakan", label: "Samut Prakan" },
                            { value: "Samut Sakhon", label: "Samut Sakhon" },
                            {
                              value: "Samut Songkhram",
                              label: "Samut Songkhram",
                            },
                            { value: "Saraburi", label: "Saraburi" },
                            { value: "Singburi", label: "Singburi" },
                            { value: "Suphanburi", label: "Suphanburi" },
                            { value: "Chachoengsao", label: "Chachoengsao" },
                            { value: "Chanthaburi", label: "Chanthaburi" },
                            { value: "Chonburi", label: "Chonburi" },
                            { value: "Prachinburi", label: "Prachinburi" },
                            { value: "Rayong", label: "Rayong" },
                            { value: "Sa Kaeo", label: "Sa Kaeo" },
                            { value: "Trat", label: "Trat" },
                            { value: "Chiang Mai", label: "Chiang Mai" },
                            { value: "Chiang Rai", label: "Chiang Rai" },
                            {
                              value: "Kamphaeng Phet",
                              label: "Kamphaeng Phet",
                            },
                            { value: "Lampang", label: "Lampang" },
                            { value: "Lamphun", label: "Lamphun" },
                            { value: "Mae Hong Son", label: "Mae Hong Son" },
                            { value: "Nan", label: "Nan" },
                            { value: "Phayao", label: "Phayao" },
                            { value: "Phetchabun", label: "Phetchabun" },
                            { value: "Phichit", label: "Phichit" },
                            { value: "Phitsanulok", label: "Phitsanulok" },
                            { value: "Sukhothai", label: "Sukhothai" },
                            { value: "Tak", label: "Tak" },
                            { value: "Uttaradit", label: "Uttaradit" },
                            { value: "Amnat Charoen", label: "Amnat Charoen" },
                            { value: "Bueng Kan", label: "Bueng Kan" },
                            { value: "Buriram", label: "Buriram" },
                            { value: "Chaiyaphum", label: "Chaiyaphum" },
                            { value: "Kalasin", label: "Kalasin" },
                            { value: "Khon Kaen", label: "Khon Kaen" },
                            { value: "Loei", label: "Loei" },
                            { value: "Maha Sarakham", label: "Maha Sarakham" },
                            { value: "Mukdahan", label: "Mukdahan" },
                            { value: "Nakhon Phanom", label: "Nakhon Phanom" },
                            {
                              value: "Nakhon Ratchasima",
                              label: "Nakhon Ratchasima",
                            },
                            {
                              value: "Nong Bua Lamphu",
                              label: "Nong Bua Lamphu",
                            },
                            { value: "Nong Khai", label: "Nong Khai" },
                            { value: "Roi Et", label: "Roi Et" },
                            { value: "Sakon Nakhon", label: "Sakon Nakhon" },
                            { value: "Sisaket", label: "Sisaket" },
                            { value: "Surin", label: "Surin" },
                            {
                              value: "Ubon Ratchathani",
                              label: "Ubon Ratchathani",
                            },
                            { value: "Udon Thani", label: "Udon Thani" },
                            { value: "Yasothon", label: "Yasothon" },
                            { value: "Chumphon", label: "Chumphon" },
                            { value: "Krabi", label: "Krabi" },
                            {
                              value: "Nakhon Si Thammarat",
                              label: "Nakhon Si Thammarat",
                            },
                            { value: "Narathiwat", label: "Narathiwat" },
                            { value: "Pattani", label: "Pattani" },
                            { value: "Phang Nga", label: "Phang Nga" },
                            { value: "Phatthalung", label: "Phatthalung" },
                            { value: "Phuket", label: "Phuket" },
                            { value: "Ranong", label: "Ranong" },
                            { value: "Satun", label: "Satun" },
                            { value: "Songkhla", label: "Songkhla" },
                            { value: "Surat Thani", label: "Surat Thani" },
                            { value: "Trang", label: "Trang" },
                            { value: "Yala", label: "Yala" },
                            { value: "Kanchanaburi", label: "Kanchanaburi" },
                            { value: "Phetchaburi", label: "Phetchaburi" },
                            {
                              value: "Prachuap Khiri Khan",
                              label: "Prachuap Khiri Khan",
                            },
                            { value: "Ratchaburi", label: "Ratchaburi" },
                            { value: "Tak", label: "Tak" },
                          ]}
                          className="w-full border-none rounded-md text-center font-light"
                          styles={styleSelect}
                          value={
                            user_corporate.province
                              ? {
                                  value: user_corporate.province,
                                  label: user_corporate.province,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updateCorporate("province", option.value);
                            openPopup();
                          }}
                          placeholder="PROVINCE"
                        />
                      </div>
                    </div>
                  </>
                )}

                {typeofuser.type === "Personal" && (
                  <>
                    <div className="flex gap-10">
                      <div className="basis-[12%]">
                        <label
                          htmlFor="title"
                          className="block font-medium pt-2"
                        >
                          Title
                        </label>
                        <Select
                          options={[
                            { value: "Mr.", label: "Mr." },
                            { value: "Mrs.", label: "Mrs." },
                            { value: "Ms.", label: "Ms." },
                          ]}
                          className="w-full border-none rounded-md text-center font-light"
                          styles={styleSelect}
                          value={
                            user_personal.title
                              ? {
                                  value: user_personal.title,
                                  label: user_personal.title,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updatePersonal("title", option.value);
                            openPopup();
                          }}
                          placeholder="TITLE"
                          isSearchable={false}
                        />
                      </div>
                      <div className="basis-[44%]">
                        <label
                          htmlFor="first-name"
                          className="block font-medium pt-2"
                        >
                          First Name
                        </label>
                        <input
                          type="text"
                          id="first-name"
                          placeholder="FIRST NAME"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_personal.firstName}
                          onChange={(e) =>
                            updatePersonal("firstName", e.target.value)
                          }
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[44%]">
                        <label
                          htmlFor="last-address"
                          className="block font-medium pt-2"
                        >
                          Last Name
                        </label>
                        <input
                          type="text"
                          id="last-address"
                          placeholder="LAST NAME"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_personal.lastName}
                          onChange={(e) =>
                            updatePersonal("lastName", e.target.value)
                          }
                          onBlur={openPopup}
                        />
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[38%]">
                        <label
                          htmlFor="idcard-number"
                          className="block font-medium pt-2"
                        >
                          id card number
                        </label>
                        <input
                          type="text"
                          id="idcard-number"
                          placeholder="ID CARD"
                          maxlength={16}
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={inId}
                          onChange={(e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            setInId(value);
                          }}
                          onBlur={() => validateId(inId)}
                        />
                        {errorId && (
                          <p className="absolute text-red-500 text-xs ml-2">
                            {errorId}
                          </p>
                        )}
                      </div>
                      <div className="basis-[38%]">
                        <label
                          htmlFor="passport-number"
                          className="block font-medium pt-2"
                        >
                          PASSPORT NUMBER
                        </label>
                        <input
                          type="text"
                          id="passport-number"
                          placeholder="PASSPORT"
                          maxlength={9}
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={inPassport}
                          onChange={(e) => setInPassport(e.target.value)}
                          onBlur={() => validatePassport(inPassport)}
                        />
                        {errorPassport && (
                          <p className="absolute text-red-500 text-xs ml-2">
                            {errorPassport}
                          </p>
                        )}
                      </div>
                      <div className="basis-[24%]">
                        <label
                          htmlFor="nationality"
                          className="block font-medium pt-2"
                        >
                          NATIONALITY
                        </label>
                        <Select
                          options={countries.map((c) => ({
                            value: c,
                            label: c,
                          }))}
                          className="border-none rounded-md text-center font-light "
                          styles={styleSelect}
                          value={
                            user_personal.nationality
                              ? {
                                  value: user_personal.nationality,
                                  label: user_personal.nationality,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updatePersonal("nationality", option.value);
                            openPopup();
                          }}
                          placeholder="NATIONALITY"
                        />
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[18%]">
                        <label
                          htmlFor="date-of-birth"
                          className="block font-medium pt-2"
                        >
                          DATE OF BIRTH
                        </label>
                        <input
                          type="date"
                          id="date-of-birth"
                          className={`w-full p-2 border-none rounded-md text-center font-light ${
                            !user_personal.birthDate
                              ? "text-[#808080]"
                              : "text-black"
                          }`}
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={
                            user_personal.birthDate
                              ? user_personal.birthDate
                              : null
                          }
                          onChange={(e) => {
                            updatePersonal("birthDate", e.target.value);
                            openPopup();
                          }}
                        />
                      </div>
                      <div className="basis-[43%] ">
                        <label
                          htmlFor="phone-number"
                          className="block font-medium pt-2"
                        >
                          Phone number
                        </label>
                        <div className="flex items-center gap-2">
                          <Select
                            options={dial}
                            className="basis-[25%] border-none rounded-md text-center font-light "
                            styles={styleSelect}
                            value={
                              user_personal.countryCode
                                ? {
                                    value: user_personal.countryCode,
                                    label: user_personal.countryCode,
                                  }
                                : null
                            }
                            onChange={(option) => {
                              const filteredPhones = infoCountry.filter(
                                (item) => item.dial === option.value
                              );
                              setPhone(filteredPhones[0].phone);
                              // setId(filteredPhones[0].id);
                              // setPassport(filteredPhones[0].passport);
                              updatePersonal("countryCode", option.value);
                              updatePersonal("phoneNumber", "");
                              setInPhone("");
                              setErrorPhone("");
                              console.log(filteredPhones.phone);
                              console.log(phone);
                            }}
                            placeholder="+66"
                            isSearchable={false}
                          />
                          <div className="flex flex-col basis-[75%] relative">
                            <input
                              type="text"
                              id="phone-number"
                              maxlength={10}
                              placeholder="81 123 4567"
                              className=" p-2 border-none rounded-md  text-center  font-light text-ellipsis placeholder-[#808080]"
                              style={{
                                boxShadow:
                                  "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                              }}
                              value={inPhone}
                              onChange={(e) => {
                                let value = e.target.value.replace(/\D/g, "");
                                setInPhone(value);
                              }}
                              onBlur={() => validatePhone(inPhone)}
                            />
                            {errorPhone && (
                              <p className="absolute top-full text-red-500 text-xs ml-2">
                                {errorPhone}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="basis-[39%]">
                        <label
                          htmlFor="email"
                          className="block font-medium pt-2"
                        >
                          email
                        </label>
                        <input
                          type="email"
                          id="email"
                          placeholder="EMAIL"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={inEmail}
                          onChange={(e) => {
                            setInEmail(e.target.value);
                          }}
                          onBlur={() => validateEmail(inEmail)}
                        />
                        {emailError && (
                          <p className="absolute text-red-500 text-xs ml-2">
                            {emailError}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-10">
                      <div className="basis-[38%]">
                        <label
                          htmlFor="address"
                          className="block font-medium pt-2"
                        >
                          address
                        </label>
                        <input
                          type="text"
                          id="address"
                          placeholder="ADDRESS"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_personal.address}
                          onChange={(e) =>
                            updatePersonal("address", e.target.value)
                          }
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[20%]">
                        <label
                          htmlFor="city"
                          className="block font-medium pt-2"
                        >
                          City
                        </label>
                        <Select
                          options={[
                            { value: "Johor", label: "Johor" },
                            { value: "Kedah", label: "Kedah" },
                            { value: "Kelantan", label: "Kelantan" },
                            {
                              value: "Malacca (Melaka)",
                              label: "Malacca (Melaka)",
                            },
                            {
                              value: "Negeri Sembilan",
                              label: "Negeri Sembilan",
                            },
                            { value: "Pahang", label: "Pahang" },
                            {
                              value: "Penang (Pulau Pinang)",
                              label: "Penang (Pulau Pinang)",
                            },
                            { value: "Perak", label: "Perak" },
                            { value: "Perlis", label: "Perlis" },
                            { value: "Sabah", label: "Sabah" },
                            { value: "Sarawak", label: "Sarawak" },
                            { value: "Selangor", label: "Selangor" },
                            { value: "Terengganu", label: "Terengganu" },
                            { value: "Kuala Lumpur", label: "Kuala Lumpur" },
                            { value: "Labuan", label: "Labuan" },
                            { value: "Putrajaya", label: "Putrajaya" },
                          ]}
                          className="w-full border-none rounded-md text-center font-light "
                          styles={styleSelect}
                          value={
                            user_personal.city
                              ? {
                                  value: user_personal.city,
                                  label: user_personal.city,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updatePersonal("city", option.value);
                            openPopup();
                          }}
                          placeholder="CITY"
                        />
                      </div>
                      <div className="basis-[20%]">
                        <label
                          htmlFor="zip-code"
                          className="block font-medium pt-2"
                        >
                          zip code
                        </label>
                        <input
                          type="text"
                          id="zip-code"
                          placeholder="ZIP"
                          className="w-full p-2 border-none rounded-md  text-center font-light text-ellipsis placeholder-[#808080]"
                          style={{
                            boxShadow:
                              "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                          }}
                          value={user_personal.zipCode}
                          onChange={(e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            updatePersonal("zipCode", value);
                          }}
                          onBlur={openPopup}
                        />
                      </div>
                      <div className="basis-[22%]">
                        <label
                          htmlFor="province"
                          className="block font-medium pt-2"
                        >
                          to province
                        </label>
                        <Select
                          options={[
                            { value: "Ang Thong", label: "Ang Thong" },
                            { value: "Ayutthaya", label: "Ayutthaya" },
                            { value: "Bangkok", label: "Bangkok" },
                            { value: "Chainat", label: "Chainat" },
                            { value: "Lopburi", label: "Lopburi" },
                            { value: "Nakhon Nayok", label: "Nakhon Nayok" },
                            { value: "Nakhon Pathom", label: "Nakhon Pathom" },
                            { value: "Nonthaburi", label: "Nonthaburi" },
                            { value: "Pathum Thani", label: "Pathum Thani" },
                            { value: "Samut Prakan", label: "Samut Prakan" },
                            { value: "Samut Sakhon", label: "Samut Sakhon" },
                            {
                              value: "Samut Songkhram",
                              label: "Samut Songkhram",
                            },
                            { value: "Saraburi", label: "Saraburi" },
                            { value: "Singburi", label: "Singburi" },
                            { value: "Suphanburi", label: "Suphanburi" },
                            { value: "Chachoengsao", label: "Chachoengsao" },
                            { value: "Chanthaburi", label: "Chanthaburi" },
                            { value: "Chonburi", label: "Chonburi" },
                            { value: "Prachinburi", label: "Prachinburi" },
                            { value: "Rayong", label: "Rayong" },
                            { value: "Sa Kaeo", label: "Sa Kaeo" },
                            { value: "Trat", label: "Trat" },
                            { value: "Chiang Mai", label: "Chiang Mai" },
                            { value: "Chiang Rai", label: "Chiang Rai" },
                            {
                              value: "Kamphaeng Phet",
                              label: "Kamphaeng Phet",
                            },
                            { value: "Lampang", label: "Lampang" },
                            { value: "Lamphun", label: "Lamphun" },
                            { value: "Mae Hong Son", label: "Mae Hong Son" },
                            { value: "Nan", label: "Nan" },
                            { value: "Phayao", label: "Phayao" },
                            { value: "Phetchabun", label: "Phetchabun" },
                            { value: "Phichit", label: "Phichit" },
                            { value: "Phitsanulok", label: "Phitsanulok" },
                            { value: "Sukhothai", label: "Sukhothai" },
                            { value: "Tak", label: "Tak" },
                            { value: "Uttaradit", label: "Uttaradit" },
                            { value: "Amnat Charoen", label: "Amnat Charoen" },
                            { value: "Bueng Kan", label: "Bueng Kan" },
                            { value: "Buriram", label: "Buriram" },
                            { value: "Chaiyaphum", label: "Chaiyaphum" },
                            { value: "Kalasin", label: "Kalasin" },
                            { value: "Khon Kaen", label: "Khon Kaen" },
                            { value: "Loei", label: "Loei" },
                            { value: "Maha Sarakham", label: "Maha Sarakham" },
                            { value: "Mukdahan", label: "Mukdahan" },
                            { value: "Nakhon Phanom", label: "Nakhon Phanom" },
                            {
                              value: "Nakhon Ratchasima",
                              label: "Nakhon Ratchasima",
                            },
                            {
                              value: "Nong Bua Lamphu",
                              label: "Nong Bua Lamphu",
                            },
                            { value: "Nong Khai", label: "Nong Khai" },
                            { value: "Roi Et", label: "Roi Et" },
                            { value: "Sakon Nakhon", label: "Sakon Nakhon" },
                            { value: "Sisaket", label: "Sisaket" },
                            { value: "Surin", label: "Surin" },
                            {
                              value: "Ubon Ratchathani",
                              label: "Ubon Ratchathani",
                            },
                            { value: "Udon Thani", label: "Udon Thani" },
                            { value: "Yasothon", label: "Yasothon" },
                            { value: "Chumphon", label: "Chumphon" },
                            { value: "Krabi", label: "Krabi" },
                            {
                              value: "Nakhon Si Thammarat",
                              label: "Nakhon Si Thammarat",
                            },
                            { value: "Narathiwat", label: "Narathiwat" },
                            { value: "Pattani", label: "Pattani" },
                            { value: "Phang Nga", label: "Phang Nga" },
                            { value: "Phatthalung", label: "Phatthalung" },
                            { value: "Phuket", label: "Phuket" },
                            { value: "Ranong", label: "Ranong" },
                            { value: "Satun", label: "Satun" },
                            { value: "Songkhla", label: "Songkhla" },
                            { value: "Surat Thani", label: "Surat Thani" },
                            { value: "Trang", label: "Trang" },
                            { value: "Yala", label: "Yala" },
                            { value: "Kanchanaburi", label: "Kanchanaburi" },
                            { value: "Phetchaburi", label: "Phetchaburi" },
                            {
                              value: "Prachuap Khiri Khan",
                              label: "Prachuap Khiri Khan",
                            },
                            { value: "Ratchaburi", label: "Ratchaburi" },
                            { value: "Tak", label: "Tak" },
                          ]}
                          className="w-full border-none rounded-md text-center font-light"
                          styles={styleSelect}
                          value={
                            user_personal.province
                              ? {
                                  value: user_personal.province,
                                  label: user_personal.province,
                                }
                              : null
                          }
                          onChange={(option) => {
                            updatePersonal("province", option.value);
                            openPopup();
                          }}
                          placeholder="PROVINCE"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Stability */}
              {pkg !== "ta" && (
                <div
                  id="STABILITY"
                  className="space-y-1 text-center px-10 pt-20 "
                >
                  <h2 className="text-center font-semibold text-2xl">
                    Stability
                  </h2>
                  <div className="flex gap-10 justify-center">
                    <div className="w-full basis-[36%]">
                      <label
                        htmlFor="travel-start"
                        className="block font-medium pt-2"
                      >
                        Travel Start Date
                      </label>
                      <input
                        type="date"
                        id="travel-start"
                        data-date-format="DD MM YYYY"
                        className={`w-full p-2 border-none rounded-md text-center font-light ${
                          !travel.travelStart ? "text-[#808080]" : "text-black"
                        }`}
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={travel.travelStart}
                        min={localToday}
                        onChange={(e) => {
                          updateTravel("travelStart", e.target.value);
                          // รีเซ็ต returnDate ถ้าวันกลับน้อยกว่าวันเริ่มต้น
                          if (
                            travel.returnDate &&
                            new Date(e.target.value) >
                              new Date(travel.returnDate)
                          ) {
                            updateTravel("returnDate", "");
                          }
                          openPopup();
                        }}
                      />
                    </div>
                    <div className="w-full basis-[36%]">
                      <label
                        htmlFor="return-date"
                        className="block font-medium pt-2"
                      >
                        Return Date
                      </label>
                      <input
                        type="date"
                        id="return-date"
                        className={`w-full p-2 border-none rounded-md text-center font-light ${
                          !travel.travelStart
                            ? "text-[#808080] pointer-events-none opacity-80"
                            : `${
                                !travel.returnDate
                                  ? "text-[#808080]"
                                  : "text-black"
                              }`
                        }`}
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={travel.returnDate}
                        onChange={(e) => {
                          const select = new Date(e.target.value);
                          if (select < maxDate) {
                            updateTravel("returnDate", select);
                            openPopup();
                          } else {
                            console.log(select);
                            console.log(maxDate);
                            alert(
                              "Please choose the addithional days you would like coverage for."
                            );
                          }
                        }}
                        min={travel.travelStart}
                      />
                    </div>
                  </div>
                  <div className="flex gap-10 justify-center space-y-1">
                    <div className="w-full basis-[41%]">
                      <label
                        htmlFor="departure-port"
                        className="block font-medium pt-2 "
                      >
                        DEPARTURE PORT ( MALAYSIA )
                      </label>
                      <Select
                        options={[
                          {
                            value: "Bukit Kayu Hitam",
                            label: "Bukit Kayu Hitam - Sadoa",
                          },
                          {
                            value: "Padang Besar",
                            label: "Padang Besar - Padangbesa",
                          },
                          {
                            value: "Kota Putra",
                            label: "Kota Putra - Banprakob",
                          },
                          {
                            value: "Rantau Panjang",
                            label: "Rantau Panjang - Su-ngai Kolok",
                          },
                          {
                            value: "Bukit Bunga",
                            label: "Bukit Bunga - Buketa",
                          },
                          {
                            value: "Pengkalan Kubor",
                            label: "Pengkalan Kubor - Takbai",
                          },
                          {
                            value: "Pengkalan Hulu",
                            label: "Pengkalan Hulu - Betong",
                          },
                        ]}
                        className="w-full border-none rounded-md text-center font-light "
                        styles={styleSelect}
                        value={
                          travel.departurePort
                            ? {
                                value: travel.departurePort,
                                label: travel.departurePort,
                              }
                            : null
                        }
                        onChange={(option) => {
                          updateTravel("departurePort", option.value);
                          openPopup();
                        }}
                        placeholder="DEPARTURE"
                        isSearchable={false}
                      />
                    </div>
                    <div className="w-full basis-[41%]">
                      <label
                        htmlFor="arrival-port"
                        className="block font-medium pt-2"
                      >
                        ARRIVAL PORT ( THAILAND )
                      </label>
                      <Select
                        options={[
                          { value: "Sadoa", label: "Sadoa - Bukit Kayu Hitam" },
                          {
                            value: "Padangbesa",
                            label: "Padangbesa - Padang Besar",
                          },
                          {
                            value: "Banprakob",
                            label: "Banprakob - Kota Putra",
                          },
                          {
                            value: "Su-ngai Kolok",
                            label: "Su-ngai Kolok - Rantau Panjang",
                          },
                          { value: "Buketa", label: "Buketa - Bukit Bunga" },
                          {
                            value: "Takbai",
                            label: "Takbai - Pengkalan Kubor",
                          },
                          { value: "Betong", label: "Betong - Pengkalan Hulu" },
                        ]}
                        className="w-full border-none rounded-md text-center font-light "
                        styles={styleSelect}
                        value={
                          travel.arrivalPort
                            ? {
                                value: travel.arrivalPort,
                                label: travel.arrivalPort,
                              }
                            : null
                        }
                        onChange={(option) => {
                          updateTravel("arrivalPort", option.value);
                          openPopup();
                        }}
                        placeholder="ARRIVAL"
                        isSearchable={false}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Dates in Thailand */}
              <div
                id="STABILITY"
                className="space-y-1 text-center px-10 mt-6 py-2"
                style={{
                  background:
                    "linear-gradient(to right, rgba(255, 255, 255, 0)0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 0.9) 50%, rgba(255, 255, 255, 0.5) 75%, rgba(255, 255, 255, 0) 100%)",
                  filter: "drop-shadow(0px 3px 21.3px rgba(0, 0, 0, 0.1))",
                }}
              >
                <label className="text-lg font-medium ">
                  Dates in Thailand
                </label>
                <div className="flex gap-4 items-center justify-center text-[#BC0000] pb-2 font-light">
                  <div
                    className="py-2 px-16 rounded-[44px] bg-gray-100 text-center"
                    style={{
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    {travel.travelStart && travel.returnDate
                      ? `${calculateDays()} DAYS`
                      : "Please select dates"}
                  </div>
                </div>
              </div>

              {/* NUMBER OF PASSENGERS */}

              {pkg !== "ta" && (
                <div>
                  <div
                    id="PASSENGERS INFORMATION"
                    className="space-y-1 text-center bg mt-6 py-2 "
                  >
                    <label className="text-base font-medium ">
                      NUMBER OF PASSENGERS
                    </label>
                    <div className="flex items-center justify-center">
                      <input
                        type="number"
                        id="numberPassenger"
                        className="py-2 w-[10vw] border-none rounded-[44px] text-center font-light no-spin"
                        style={{
                          boxShadow:
                            "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                        }}
                        value={travel.numberPassenger}
                        onChange={(e) => handleNumberPassengerChange(e)}
                        min={1}
                      />
                    </div>
                  </div>
                  <Passengers
                    numberPassenger={travel.numberPassenger}
                    passengers={passengers}
                    handlePassengerChange={handlePassengerChange}
                    country={countries}
                    valid={validateIdPass}
                    error={error}
                    openPopup={openPopup}
                  />
                </div>
              )}
            </form>
          </div>
          <div className="space-y-4 p-4 w-[65vw] text-gray-700 font-poppins font-normal">
            <div className="flex items-start space-x-2">
              <input
                type="checkbox"
                name="privacy"
                checked={checked.privacy}
                onChange={handleChange}
                className="w-5 h-5 mt-1  rounded focus:ring-red-500"
                style={{
                  boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                }}
              />
              <div className="flex flex-col w-full md:flex-col text-center text-[9px] pl-4 pt-1 justify-center">
                <span>
                  I accept the terms and privacy policy, including the
                  collection and use of personal data in accordance with the
                  <a className="text-red-500 font-medium">
                    {" "}
                    Personal Data Protection Act (PDPA)
                  </a>
                  .{" "}
                  <span
                    className="underline cursor-pointer pl-1"
                    onClick={() => setPdpa(true)}
                  >
                    (Read more)
                  </span>
                </span>
                <span>
                  Saya menerima terma dan dasar privasi, termasuk pengumpulan
                  dan penggunaan data peribadi selaras dengan Akta Perlindungan
                  Data Peribadi
                  <a className="text-red-500 font-medium"> (PDPA)</a>
                  <span
                    className="underline cursor-pointer pl-1"
                    onClick={() => setPdpa(true)}
                  >
                    (Baca lebih lanjut)
                  </span>
                </span>
                <span>
                  本人接受条款和隐私政策，包括根据个人数据保护法
                  <a className="text-red-500 font-medium"> (PDPA)</a>{" "}
                  收集和使用个人数据，以用于订单处理和提供服务。
                  <span
                    className="underline cursor-pointer pl-1"
                    onClick={() => setPdpa(true)}
                  >
                    (阅读更多)
                  </span>
                </span>
              </div>
            </div>

            <div className="flex items-start space-x-2">
              <input
                type="checkbox"
                name="reservation"
                checked={checked.reservation}
                onChange={handleChange}
                className="w-5 h-5 mt-1  rounded focus:ring-red-500"
                style={{
                  boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                }}
              />
              <div className="flex flex-col w-full md:flex-col text-center text-[9px] pl-4 pt-1 justify-center">
                <span>
                  I accept the terms and conditions of the website regarding the
                  reservation of the
                  <a className="text-red-500 font-medium">
                    {" "}
                    right to cancel, amend,
                  </a>{" "}
                  or
                  <a className="text-red-500 font-medium">
                    {" "}
                    modify under any circumstances
                  </a>{" "}
                  at the company's discretion.
                </span>
                <span>
                  Saya menerima terma dan syarat laman web berkenaan pengekalan
                  hak untuk membatalkan, meminda, atau mengubah dalam apa jua
                  keadaan mengikut budi bicara syarikat.
                </span>
                <span>
                  本人接受网站的条款和条件，关于公司有权在任何情况下自行决定取消、修改或更改。
                </span>
              </div>
            </div>

            <div className="flex items-start space-x-2">
              <input
                type="checkbox"
                name="marketing"
                checked={checked.marketing}
                onChange={handleChange}
                className="w-5 h-5 mt-1 rounded focus:ring-red-500 "
                style={{
                  boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                }}
              />
              <div className="flex flex-col w-full md:flex-col text-center text-[9px] pl-4 pt-1 justify-center">
                <span>
                  I consent to being contacted for marketing purposes, including
                  promotions, news, and special offers via email or SMS.
                </span>
              </div>
            </div>
          </div>
          <div
            id="PAYMENT"
            className="flex w-[65vw] mx-1 flex-col lg:flex-row items-center justify-center gap-8 px-6 pb-6 pt-9"
          >
            {/* บัตรเครดิต */}
            <div
              className="w-[408px] h-[254px]  rounded-xl relative shadow-lg px-4 py-2"
              style={{
                background:
                  "linear-gradient(33deg, #31415B 0%,  #0F2C59 12%, #060606 34%, #283A78 48%, #000000 62%, #4C6495 80%, #000000 95%, #262626 100%)",
                boxShadow:
                  "inset -5px -5px 4px rgba(0, 0, 0, 0.8),inset 4px 4px 1.8px rgba(255, 255, 255, 0.7)",
                filter: "drop-shadow(4px 3px 1.7px rgba(0, 0, 0, 0.5))",
              }}
            >
              {/* โลโก้ด้านบน */}
              <div className="flex justify-between items-center">
                <div>
                  <img
                    src="./logo.png"
                    alt="Cross Border Logo"
                    className="h-12"
                  />
                </div>
                <div className="flex gap-2">
                  <img src="./VISA.png" alt="Visa Logo" className="h-8" />
                </div>
              </div>

              {/* เนื้อหาบัตร */}
              <div className="mt-8 text-white pb-2">
                <p className="text-sm">CARD NUMBER</p>
                <p className="text-2xl tracking-wider font-semibold px-4 w-full">
                  XXXX XXXX XXXX{" "}
                  <span className="font-bold">
                    {creditCard.cardNumber.length >= 13
                      ? creditCard.cardNumber.slice(
                          -Math.min(4, creditCard.cardNumber.length - 12)
                        )
                      : "XXXX"}
                  </span>
                </p>

                <div className="flex justify-between mt-6">
                  <div>
                    <p className="text-sm">NAME</p>
                    <p className="text-lg font-bold pl-4">
                      {creditCard.cardHolder
                        ? creditCard.cardHolder
                        : "CREDITCARD NAME"}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm">MONTH AND YEAR</p>
                    <p className="text-lg font-bold pr-4 right-0">
                      {" "}
                      {creditCard.expirationDate
                        ? creditCard.expirationDate
                        : "MM / YY"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* ฟอร์มกรอกข้อมูล */}
            <form className="bg-transparent p-6 rounded-lg w-full max-w-md space-y-4 border-none uppercase">
              <div className="block text-sm font-normal">
                <label className="block text-sm font-normal">
                  Cardholder name
                </label>
                <input
                  type="text"
                  value={creditCard.cardHolder}
                  onChange={(e) =>
                    updateCreditCard("cardHolder", e.target.value)
                  }
                  placeholder="CARDHOLDER NAME"
                  className="w-full p-2 border-none rounded-md  font-light text-ellipsis text-center placeholder-[#808080]"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                />
              </div>
              <div>
                <label className="block text-sm font-normal">Card Number</label>
                <input
                  type="text"
                  value={creditCard.cardNumber}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    updateCreditCard("cardNumber", value);
                  }}
                  placeholder="1234 5678 1234 5678"
                  className="w-full p-2 border-none rounded-md  font-light text-ellipsis text-center placeholder-[#808080]"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                />
              </div>
              <div className="grid grid-cols-2 gap-4 mr-6">
                <div>
                  <label className="block text-sm font-normal">
                    Month and Year
                  </label>
                  <input
                    type="text"
                    value={creditCard.expirationDate}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      if (value.length > 4) value = value.slice(0, 4);

                      if (value.length >= 2) {
                        value = `${value.slice(0, 2)}/${value.slice(2)}`;
                      }
                      updateCreditCard("expirationDate", value);
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key === "Backspace" &&
                        creditCard.expirationDate.length === 3
                      ) {
                        updateCreditCard(
                          "expirationDate",
                          creditCard.expirationDate.slice(0, 2)
                        );
                        e.preventDefault();
                      }
                    }}
                    placeholder="MM/YY"
                    className="w-full p-2 border-none rounded-md  font-light text-ellipsis text-center placeholder-[#808080]"
                    style={{
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                    }}
                  />
                </div>
                <div>
                  <label className="block text-sm font-normal">CVV Code</label>
                  <input
                    type="text"
                    value={creditCard.cvv}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      if (value.length > 3) value = value.slice(0, 3);
                      updateCreditCard("cvv", value);
                    }}
                    placeholder="123"
                    className="w-full p-2 border-none rounded-md  font-light text-center placeholder-[#808080]"
                    style={{
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                    }}
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="flex justify-center items-center mt-6">
            <button
              onClick={handlePayment}
              className="bg-[#0F2C59] text-white font-bold py-2 px-12 rounded-md relative left-[-14%] hover:shadow-lg hover:bg-blue-800 active:translate-y-1 transition duration-150 ease-in-out"
              style={{
                filter: "drop-shadow(3px 3px 4px 0px rgba(0, 0, 0, 0.6))",
                boxShadow:
                  "inset 2px -2px 4px 0px rgba(0, 0, 0, 0.5) inset -2px 2px 4px 0px rgba(255, 255, 255, 0.5)",
              }}
            >
              PAY NOW
            </button>
          </div>

          <div className="relative w-full h-[45vh] bg-transparent" />
        </div>
        <div
          className="w-full h-[38vh] bg-[#FFFFFF50] flex justify-center items-center absolute bottom-0 z-10  backdrop-blur-[27.8px]"
          style={{
            filter: "drop-shadow(0px -3px 14.1px rgba(0, 0, 0, 0.25))",
          }}
        >
          <img src="/lastbanner.png" className="w-auto h-[38vh]" alt="" />
        </div>
      </div>
      <Receipt pkg={pkg} price={price} />
      <Footer />
    </div>
  );
};

const Passengers = ({
  numberPassenger,
  passengers,
  handlePassengerChange,
  country,
  valid,
  error,
  openPopup,
}) => {
  return (
    <div className="mt-6 space-y-1">
      {Array.from({ length: numberPassenger }).map((_, index) => (
        <div
          key={index}
          className="flex pb-6 flex-row px-10 w-full font-poppins text-black"
        >
          <h3 className="w-10 h-10 text-xl text-[#D70000] bg-white rounded-full p-2 flex items-center justify-center mt-6">
            {index + 1}
          </h3>
          <div className="w-full ml-10 space-y-1">
            {/* First Name, Last Name, Age */}
            <div id="PASSENGERS INFORMATION" className="flex grid-cols-3 gap-4">
              <div className=" basis-[43%]">
                <label className="block text-sm font-medium pt-2">
                  First Name
                </label>
                <input
                  type="text"
                  placeholder="FIRST NAME"
                  value={passengers[index]?.firstName || ""}
                  onChange={(e) =>
                    handlePassengerChange(index, "firstName", e.target.value)
                  }
                  onBlur={openPopup}
                  className="w-full p-2 border-none rounded-md text-center font-light text-ellipsis placeholder-[#808080]"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                />
              </div>
              <div className="basis-[43%]">
                <label className="block text-sm font-medium pt-2">
                  Last Name
                </label>
                <input
                  type="text"
                  placeholder="LAST NAME"
                  value={passengers[index]?.lastName || ""}
                  onChange={(e) =>
                    handlePassengerChange(index, "lastName", e.target.value)
                  }
                  onBlur={openPopup}
                  className="w-full p-2 border-none rounded-md text-center font-light text-ellipsis placeholder-[#808080]"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                />
              </div>
              <div className=" basis-[14%]">
                <label className="block text-sm font-medium pt-2">Age</label>
                <input
                  type="text"
                  placeholder="AGE"
                  value={passengers[index]?.age || ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    handlePassengerChange(index, "age", value);
                  }}
                  onBlur={openPopup}
                  className="w-full p-2 border-none rounded-md text-center font-light text-ellipsis placeholder-[#808080]"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                />
              </div>
            </div>
            {/* Nationality, ID Card Number */}
            <div
              id={
                index === numberPassenger ? "PASSENGERS INFORMATION" : "PAYMENT"
              }
              className="flex grid-cols-2 gap-4"
            >
              <div className="basis-[24%]">
                <label className="block text-sm font-medium pt-2">
                  Nationality
                </label>
                <Select
                  options={country.map((c) => ({
                    value: c,
                    label: c,
                  }))}
                  styles={{
                    control: (base) => ({
                      ...base,
                      boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                      border: "none",
                    }),
                    indicatorSeparator: () => ({
                      display: "none",
                    }),
                    dropdownIndicator: (provided) => ({
                      ...provided,
                      padding: "0px",
                      paddingRight: "4px",
                    }),
                    option: (provided) => ({
                      ...provided,
                      textTransform: "none",
                      backgroundColor: "white",
                      textAlign: "center",
                      fontFamily: "Poppins",
                      fontWeight: "300",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body} // ให้เมนูลอยนอกกล่อง
                  menuPosition="fixed"
                  placeholder="Nationality"
                  value={
                    passengers[index]?.nationality
                      ? {
                          value: passengers[index]?.nationality,
                          label: passengers[index]?.nationality,
                        }
                      : null
                  }
                  onChange={(e) => {
                    handlePassengerChange(index, "nationality", e.value);
                    console.log(passengers[index]?.nationality);
                    openPopup();
                  }}
                  className="w-full border-none rounded-md text-center font-light"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                />
              </div>
              <div className="basis-[40%]">
                <label className="block text-sm font-medium pt-2">
                  ID Card Number
                </label>
                <input
                  type="text"
                  placeholder="NUMBER"
                  maxLength={16}
                  value={passengers[index]?.idCardNumber || ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    handlePassengerChange(index, "idCardNumber", value);
                  }}
                  className="w-full p-2 border-none rounded-md text-center font-light text-ellipsis placeholder-[#808080]"
                  style={{
                    boxShadow: "inset 0px 0px 4px 3px rgba(0, 0, 0, 0.25)",
                  }}
                  onBlur={() => valid(index, passengers[index]?.idCardNumber)}
                />
                {error[index]?.errorId && (
                  <p className="absolute text-red-500 text-xs ml-2">
                    {error[index]?.errorId}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Info;
